var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.37,303.22l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45L665.39,292v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V292c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05L679,303Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.6,317.33l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.57.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.14,317.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79,170.07l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,184.18l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05h-.44v-.45L273,173v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V173c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5L274,184.18l-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,184.18l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.05h-.44v-.45L302.58,173v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V173c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.88,244.11l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05H72v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.86,170.06l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.84,61.38l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.61,75.49l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.14,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,61.39l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5L43.3,61.39,42.86,61c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.77,143.5a36.38,36.38,0,1,1-45.64-23.9A36.39,36.39,0,0,1,124.77,143.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,186.53a33.78,33.78,0,1,1,22.1-42.25A33.76,33.76,0,0,1,100.19,186.53Zm19-40.7A30.32,30.32,0,1,0,98.23,183.5,30.35,30.35,0,0,0,119.14,145.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,134.05,86.81,133l.3,1c.41,1.29.84,2.58,1.22,3.88.14.48.35.54.83.47a26.63,26.63,0,0,1,4.33-.51c3.72,0,6.15,2.07,7,5.7a17,17,0,0,1,.36,2,5.32,5.32,0,0,1-1.68,4.45c-.28.29-.58.57-.93.91.62.06,1.17.08,1.71.16a7.24,7.24,0,0,1,6.15,5.16,10.53,10.53,0,0,1,.7,4.16,7,7,0,0,1-2.39,4.93,16.74,16.74,0,0,1-5.71,3.18c-.49.18-.64.35-.46.87.43,1.27.78,2.56,1.18,3.83.1.31.07.52-.26.62l-2.84.9-.38-1.2c-.34-1.07-.69-2.15-1-3.23-.11-.37-.26-.5-.66-.36-.61.22-1.24.4-1.92.61.52,1.67,1,3.27,1.54,4.9l-3.32,1.05c-.52-1.63-1-3.22-1.55-4.89l-8.23,2.6c-.59-1.89-1.16-3.7-1.76-5.58l2.43-.77c-2-6.4-4-12.73-6-19.12l-2.41.76c-.59-1.86-1.16-3.67-1.76-5.55l8.19-2.59-1.71-5.42,3.3-1c.55,1.76,1.11,3.52,1.69,5.34l2.44-.77C84.63,137.63,84.07,135.87,83.5,134.05Zm6.65,22.64c-.55.17-1.09.36-1.64.51-.37.1-.44.27-.33.63q1.06,3.3,2.09,6.62c.14.43.34.48.72.35,1-.32,1.92-.6,2.87-.92a3.66,3.66,0,0,0,2.61-4.19,3.8,3.8,0,0,0-5.2-3.36Zm-4.67-7.46c.29.94.6,1.88.88,2.82.1.32.24.45.58.33,1-.34,2-.63,3-1a2.28,2.28,0,0,0,1.5-2.49,7.84,7.84,0,0,0-.52-2.08,2.88,2.88,0,0,0-3.74-1.69c-.75.23-1.48.48-2.23.69-.37.11-.44.28-.33.63C84.89,147.35,85.18,148.3,85.48,149.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,127.42a30.1,30.1,0,0,1,9.41,7.26,30.64,30.64,0,0,1,5.86,10.41A29.9,29.9,0,0,1,120.67,157a30.37,30.37,0,0,1-10.89,20.88,30,30,0,0,1-10.55,5.7,30.67,30.67,0,0,1-11.89,1.16A29.92,29.92,0,0,1,76,181.18a30.47,30.47,0,0,0,33.22-4,30.54,30.54,0,0,0,10.59-20.29A30.56,30.56,0,0,0,104,127.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79,181.2a30,30,0,0,1-9.39-7.29,30.65,30.65,0,0,1-5.83-10.43,30.06,30.06,0,0,1-1.33-11.92,30.3,30.3,0,0,1,10.95-20.84,29.8,29.8,0,0,1,10.56-5.67,30.72,30.72,0,0,1,11.9-1.13,30.22,30.22,0,0,1,11.33,3.6,30.51,30.51,0,0,0-33.23,3.86A30.51,30.51,0,0,0,60.1,151.64,30.53,30.53,0,0,0,75.79,181.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,149.43c-.18-.45-.35-.91-.51-1.37s-.34-.91-.49-1.37l-1-2.75-.07-.19.2-.07q4.08-1.37,8.19-2.58l-.13.25-.78-2.73-.38-1.38-.36-1.37c.17.44.34.89.5,1.33l.48,1.34.93,2.69.06.19-.2.06q-4.07,1.36-8.19,2.59l.14-.26.8,2.8c.14.47.26.94.39,1.41S72.92,149,73,149.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.81,174.14c-.33-.92-.65-1.84-1-2.76s-.63-1.85-.94-2.77l-.05-.15.15-.05,2.42-.81-.13.25-1.54-4.77c-.51-1.59-1-3.19-1.49-4.79s-1-3.19-1.44-4.8-.93-3.21-1.37-4.82c.56,1.57,1.12,3.15,1.65,4.74s1.06,3.16,1.57,4.76,1,3.17,1.53,4.77l1.48,4.79.06.2-.19.06-2.45.72.1-.2c.28.94.57,1.87.82,2.81S80.56,173.19,80.81,174.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,164.8c.52-.22,1-.4,1.55-.61l1.57-.56a3.56,3.56,0,0,0,2-2.23,4.24,4.24,0,0,0-.29-3.06,3.87,3.87,0,0,0-.94-1.29,3.79,3.79,0,0,0-1.38-.86,3.83,3.83,0,0,1,2.65,2,4.33,4.33,0,0,1,.42,3.38A3.7,3.7,0,0,1,94.22,164C93.15,164.27,92.08,164.56,91,164.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.06,152.34c.84-.37,1.71-.7,2.54-1a2.76,2.76,0,0,0,1.46-2,4,4,0,0,0-.42-2.51,4.48,4.48,0,0,0-1.81-1.93A3.9,3.9,0,0,1,91,146.69a4,4,0,0,1,.56,2.78,2.94,2.94,0,0,1-1.78,2.21C88.84,152,88,152.15,87.06,152.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,171.54a14,14,0,0,1,1.55,4.89,11.94,11.94,0,0,1-1-2.37A12.58,12.58,0,0,1,89,171.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,169.83a12.56,12.56,0,0,1,1,2.37,12.23,12.23,0,0,1,.54,2.5,11.61,11.61,0,0,1-1-2.36A12.32,12.32,0,0,1,94.67,169.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.28,256.5a36.38,36.38,0,1,1-33.93-38.77A36.39,36.39,0,0,1,696.28,256.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.82,287.75a33.79,33.79,0,1,1,35.87-31.42A33.76,33.76,0,0,1,657.82,287.75Zm32.37-31.11a30.32,30.32,0,1,0-33.1,27.58A30.34,30.34,0,0,0,690.19,256.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.2,232.78l3.47.22c0,.36,0,.68-.06,1-.09,1.36-.15,2.71-.27,4.06,0,.5.13.63.61.74a26.14,26.14,0,0,1,4.22,1.09c3.46,1.37,5,4.15,4.49,7.85a19.38,19.38,0,0,1-.38,2,5.35,5.35,0,0,1-3.18,3.54c-.37.17-.75.32-1.19.51.55.28,1.05.5,1.53.77a7.27,7.27,0,0,1,3.88,7,10.67,10.67,0,0,1-.85,4.13,7,7,0,0,1-4,3.74,16.78,16.78,0,0,1-6.47.9c-.52,0-.72.09-.74.65-.06,1.33-.2,2.66-.28,4,0,.33-.12.51-.47.49l-3-.19c0-.45.05-.85.08-1.25.07-1.13.13-2.26.22-3.38,0-.39-.06-.57-.48-.58-.65,0-1.3-.07-2-.12-.11,1.75-.22,3.42-.33,5.13l-3.48-.22c.11-1.71.22-3.38.33-5.13l-8.61-.55c.12-2,.24-3.86.37-5.83l2.54.16c.43-6.7.85-13.32,1.28-20l-2.52-.16c.12-1.95.24-3.84.37-5.81l8.57.54c.12-1.93.24-3.78.36-5.67l3.45.22c-.12,1.84-.23,3.69-.36,5.59l2.56.17C661,236.53,661.08,234.69,661.2,232.78Zm-2,23.52c-.58,0-1.15-.06-1.72-.12-.38,0-.51.1-.53.47-.14,2.31-.28,4.62-.44,6.93,0,.45.14.57.54.59,1,0,2,.13,3,.17a3.66,3.66,0,0,0,3.95-3,3.81,3.81,0,0,0-3.65-5Zm-1.67-8.64c-.07,1-.12,2-.2,2.94,0,.33.07.51.42.52,1.05,0,2.09.13,3.14.12a2.28,2.28,0,0,0,2.29-1.78,8.08,8.08,0,0,0,.27-2.13,2.89,2.89,0,0,0-2.88-2.93c-.78-.06-1.56-.08-2.33-.16-.38,0-.51.1-.53.47C657.7,245.69,657.63,246.67,657.57,247.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.75,234a29.93,29.93,0,0,1,6.15,10.16A30.66,30.66,0,0,1,690.61,256a30.05,30.05,0,0,1-3,11.6,30.34,30.34,0,0,1-17.69,15.54,30.07,30.07,0,0,1-11.9,1.51,30.56,30.56,0,0,1-11.51-3.21A30,30,0,0,1,637.2,274a30.48,30.48,0,0,0,32.41,8.3,30.57,30.57,0,0,0,17.19-15.1,30.48,30.48,0,0,0-4-33.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,274a29.94,29.94,0,0,1-6.12-10.18A30.44,30.44,0,0,1,629.2,252a29.92,29.92,0,0,1,3.06-11.6A30.29,30.29,0,0,1,650,224.87a29.87,29.87,0,0,1,11.9-1.47,30.38,30.38,0,0,1,11.5,3.25,29.88,29.88,0,0,1,9.26,7.44,30.5,30.5,0,0,0-32.38-8.4A30.49,30.49,0,0,0,633,240.74,30.5,30.5,0,0,0,637,274Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.9,243.35c0-.49,0-1,0-1.46s0-1,0-1.46l.11-2.91v-.2h.21q4.29.21,8.57.55l-.21.19.25-2.83.15-1.42c.05-.47.1-.94.16-1.41,0,.47,0,1,0,1.42l0,1.42-.11,2.84v.2h-.2q-4.29-.19-8.58-.54l.22-.19-.26,2.9c0,.48-.1,1-.15,1.45S646,242.86,645.9,243.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.23,269.19c0-1,0-1.94.09-2.92s.08-1.95.12-2.92v-.16h.16l2.55.12-.22.19.29-5c.09-1.67.23-3.33.34-5s.25-3.33.39-5,.29-3.33.46-5c0,1.67-.09,3.34-.17,5s-.15,3.34-.25,5-.19,3.34-.3,5l-.35,5,0,.21-.2,0-2.54-.2.17-.15c-.09,1-.15,1.94-.25,2.91S644.33,268.23,644.23,269.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.09,264.17c.56,0,1.11,0,1.67,0l1.66,0a3.54,3.54,0,0,0,2.71-1.34,4.18,4.18,0,0,0,.83-3,4.13,4.13,0,0,0-1.38-2.85,3.88,3.88,0,0,1,1.75,2.81,4.28,4.28,0,0,1-.83,3.3,3.72,3.72,0,0,1-3.1,1.4C659.29,264.45,658.19,264.34,657.09,264.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.92,251.13c.91,0,1.85,0,2.74,0a2.74,2.74,0,0,0,2.06-1.29,4,4,0,0,0,.52-2.49,4.44,4.44,0,0,0-1-2.45,3.88,3.88,0,0,1,1.35,2.4,4,4,0,0,1-.48,2.79,3,3,0,0,1-2.46,1.42C659.72,251.41,658.84,251.27,657.92,251.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.84,269.74a12.42,12.42,0,0,1,.08,2.58,11.79,11.79,0,0,1-.41,2.55,14.15,14.15,0,0,1,.33-5.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.7,270.19a11.57,11.57,0,0,1,.08,2.56,12.23,12.23,0,0,1-.4,2.53,12.21,12.21,0,0,1-.08-2.56A12.82,12.82,0,0,1,658.7,270.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.43,101.83a36.38,36.38,0,1,1-27.7-43.44A36.4,36.4,0,0,1,531.43,101.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.69,126.92a33.78,33.78,0,1,1,40.2-25.65A33.76,33.76,0,0,1,488.69,126.92Zm36.69-25.87a30.32,30.32,0,1,0-36.87,22.27A30.33,30.33,0,0,0,525.38,101.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.33,73.09l3.4.75-.22,1c-.29,1.33-.56,2.66-.88,4-.11.49,0,.65.5.83a26.15,26.15,0,0,1,4,1.71c3.21,1.88,4.31,4.86,3.25,8.43a16.15,16.15,0,0,1-.67,1.92,5.37,5.37,0,0,1-3.68,3l-1.25.33c.5.35,1,.64,1.39,1a7.25,7.25,0,0,1,2.78,7.54,10.83,10.83,0,0,1-1.46,4,7,7,0,0,1-4.54,3.08,16.69,16.69,0,0,1-6.53-.08c-.51-.09-.73,0-.83.53-.26,1.31-.6,2.6-.88,3.9-.07.32-.2.49-.54.41l-2.91-.63c.1-.44.18-.83.27-1.23.24-1.1.47-2.21.73-3.31.09-.37,0-.56-.39-.64-.64-.11-1.28-.27-2-.42-.37,1.71-.73,3.34-1.09,5l-3.41-.75c.37-1.66.72-3.3,1.1-5l-8.44-1.84c.43-1.93.83-3.79,1.25-5.72l2.49.55c1.44-6.56,2.85-13,4.28-19.59l-2.47-.54,1.25-5.69,8.39,1.83c.41-1.89.81-3.7,1.21-5.55l3.38.73c-.4,1.81-.79,3.62-1.2,5.48l2.5.55Zm-5.49,23c-.56-.12-1.13-.23-1.68-.37-.37-.1-.52,0-.6.38-.48,2.26-1,4.53-1.48,6.79-.1.43.05.58.45.66,1,.19,2,.43,3,.63a3.66,3.66,0,0,0,4.35-2.34,3.81,3.81,0,0,0-2.85-5.5Zm-.35-8.79c-.21,1-.41,1.92-.64,2.88-.07.33,0,.51.34.57,1,.2,2.05.45,3.08.6a2.29,2.29,0,0,0,2.54-1.42,7.81,7.81,0,0,0,.58-2.06,2.88,2.88,0,0,0-2.4-3.33c-.76-.17-1.53-.32-2.28-.51-.37-.09-.52,0-.59.38C494.92,85.33,494.7,86.29,494.49,87.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.44,77.56a30.09,30.09,0,0,1,4.55,11,30.43,30.43,0,0,1-.1,11.95,29.91,29.91,0,0,1-4.74,11,30.41,30.41,0,0,1-19.83,12.7,30.07,30.07,0,0,1-12-.31,30.54,30.54,0,0,1-10.9-4.91,30.23,30.23,0,0,1-8.06-8.73,30.48,30.48,0,0,0,30.79,13.09A30.52,30.52,0,0,0,520.44,111a30.51,30.51,0,0,0,1-33.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.18,110.15a30.08,30.08,0,0,1-4.52-11,30.62,30.62,0,0,1,.14-12,29.93,29.93,0,0,1,4.77-11,30.34,30.34,0,0,1,19.88-12.63,29.84,29.84,0,0,1,12,.34,30.46,30.46,0,0,1,10.88,5,29.93,29.93,0,0,1,8,8.75,30.68,30.68,0,0,0-19.07-13,30.36,30.36,0,0,0-11.67-.2,30.59,30.59,0,0,0-19.32,12.27,30.5,30.5,0,0,0-1.1,33.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.6,81.23l.24-1.44c.09-.48.16-1,.26-1.43l.55-2.87,0-.19.21,0c2.81.56,5.6,1.17,8.39,1.83l-.24.16.68-2.76.36-1.38c.12-.46.24-.92.37-1.37-.07.47-.15.93-.23,1.4l-.25,1.4-.54,2.79,0,.2-.21,0c-2.8-.56-5.6-1.18-8.39-1.83l.24-.16-.69,2.83c-.11.47-.25.94-.37,1.41S483.74,80.76,483.6,81.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.05,106.53c.17-1,.35-1.92.53-2.88s.38-1.91.56-2.87l0-.15.16,0,2.5.5-.25.16,1-4.91c.35-1.63.73-3.26,1.09-4.89s.75-3.26,1.14-4.89.79-3.24,1.21-4.86c-.29,1.64-.59,3.29-.92,4.93s-.65,3.28-1,4.91-.68,3.27-1.05,4.9L482,101.4l0,.2-.2,0-2.48-.59.19-.12c-.23,1-.45,1.9-.69,2.84S478.3,105.58,478.05,106.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.53,103.5c.55.06,1.1.16,1.65.24l1.64.29a3.54,3.54,0,0,0,2.88-.91,4.27,4.27,0,0,0,1.27-2.81,4,4,0,0,0-.17-1.58,4,4,0,0,0-.77-1.44,3.92,3.92,0,0,1,1.31,3,4.33,4.33,0,0,1-1.32,3.14,3.73,3.73,0,0,1-3.28.92C493.66,104.11,492.59,103.83,491.53,103.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.32,90.73c.91.1,1.83.25,2.71.39a2.76,2.76,0,0,0,2.23-1,3.94,3.94,0,0,0,.89-2.38,4.51,4.51,0,0,0-.61-2.57,4,4,0,0,1,1,2.57,4,4,0,0,1-.9,2.69,3,3,0,0,1-2.65,1C496.05,91.28,495.2,91,494.32,90.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.49,108.37a14,14,0,0,1-1.1,5,14.15,14.15,0,0,1,1.1-5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.22,109.69a12.11,12.11,0,0,1-.32,2.55,11.91,11.91,0,0,1-.77,2.44,11.48,11.48,0,0,1,.31-2.55A12.15,12.15,0,0,1,492.22,109.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 253.07,
    width: 1,
    height: 32.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.81 52.24 272.18 55.82 234.96 55.82 233.34 52.24 249.18 41.28 257.96 41.28 273.81 52.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.06 30.71 257.96 41.28 249.18 41.28 248.09 30.71 259.06 30.71",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.8 52.25 272.18 55.82 234.96 55.82 233.34 52.25 273.8 52.25",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.02,
    width: 1,
    height: 32.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.76 52.24 353.13 55.82 315.92 55.82 314.29 52.24 330.14 41.28 338.91 41.28 354.76 52.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.01 30.71 338.91 41.28 330.14 41.28 329.04 30.71 340.01 30.71",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.75 52.25 353.13 55.82 315.91 55.82 314.29 52.25 354.75 52.25",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.98,
    width: 1,
    height: 32.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.71 52.24 434.08 55.82 396.87 55.82 395.25 52.24 411.09 41.28 419.87 41.28 435.71 52.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.96 30.71 419.87 41.28 411.09 41.28 409.99 30.71 420.96 30.71",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.71 52.25 434.08 55.82 396.87 55.82 395.24 52.25 435.71 52.25",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.93,
    width: 1,
    height: 32.74,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.66 52.24 515.03 55.82 477.82 55.82 476.2 52.24 492.04 41.28 500.82 41.28 516.66 52.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.92 30.71 500.82 41.28 492.04 41.28 490.94 30.71 501.92 30.71",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.66 52.25 515.03 55.82 477.82 55.82 476.19 52.25 516.66 52.25",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.88,264.22C108.31,281.25,95.2,301,92,322.35a.29.29,0,0,0,.56.1,126.25,126.25,0,0,1,5.55-17.09c8.27-2.27,16.38-4.14,20.72-12.34,4.42-8.43,3.86-19.42,3-28.61C121.8,263.92,121.13,263.9,120.88,264.22Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,305.2c5.64-12.67,12.89-25.39,22.11-35.81.06-.07.15,0,.1.1-6,7.42-10.62,15.51-15.09,23.73,4.16-4.23,8.72-8,12.66-12.49.08-.09.2,0,.13.12-3.92,4.7-8.19,9.81-13.29,13.28-1.37,2.52-2.75,5.06-4.15,7.59.34-.19.7-.37,1-.54.06,0,.12.06,0,.09-.39.2-.77.41-1.17.58-.66,1.2-1.32,2.39-2,3.59C98.5,305.7,98.13,305.47,98.25,305.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.45,300.78a74,74,0,0,0,9.65-6.44c.08-.06.2.05.11.12a50.77,50.77,0,0,1-9.62,6.56C102.43,301.1,102.29,300.87,102.45,300.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.56,319.17a.23.23,0,0,0,.46,0c.06-7,0-14.09.11-21.15,1.8-3.63,5.66-5.65,8.35-8.56a37.37,37.37,0,0,0,5-7,50.15,50.15,0,0,0,5.81-19.39c.74-7.52-2.11-32.33-5.28-31.47-1.64.45-7,12.74-8.37,16.8a117.46,117.46,0,0,0-5,20.6C89.09,285.54,89.3,302.53,90.56,319.17Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.51,288.85l0,0c.38-8.89,2.39-17.88,4.26-26.5,2-9.3,4.39-18,9.17-26.34.09-.15.32,0,.24.14a97.24,97.24,0,0,0-7.37,20.22c.32-.51.71-1,1-1.45.13-.19.43,0,.3.18a13,13,0,0,1-1.49,2.11l-.06,0c-1.65,6.64-2.83,13.43-3.84,20.21l.22-.26a.07.07,0,0,1,.11.08l-.41.67q-.75,5.16-1.45,10.28c6.12-5.24,11.35-11.41,14.31-19,0,0,.07,0,0,0-2.89,7.89-7.44,14.9-14.46,19.69l-.39,2.74c0,.19-.33.14-.32,0,0-.81,0-1.62.07-2.44A.18.18,0,0,1,90.51,288.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.39,276c4.68-7,9.06-13.77,12.48-21.49,0-.09.19,0,.15.06-2.88,7.67-6.93,15.45-12.39,21.61C93.52,276.27,93.3,276.1,93.39,276Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.61,252.74c1.94-3.43,4-6.77,5.81-10.27,0-.09.19,0,.15.09a54.51,54.51,0,0,1-5.66,10.36A.18.18,0,0,1,99.61,252.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.86,254.23s0,.06,0,.06A0,0,0,0,1,98.86,254.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,298.84a71.5,71.5,0,0,1-1.64,13.85c.07.5.14,1,.21,1.52a65.9,65.9,0,0,0,2.48-15.44.48.48,0,0,0,0-.48h0a102,102,0,0,0-1.55-20.92c-2.18-12.92-6.93-25.31-15.94-35a.65.65,0,0,0-1,.21c-3.63,9.24-2.36,20.27.73,29.5a54.21,54.21,0,0,0,7.15,14C79.35,290.42,83.29,294.1,85.8,298.84Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,246.69C79,260.55,84.92,277,85.65,293.35c0,.29-.48.37-.52.07q-.3-2.21-.66-4.38s0,0,0,0c-3.54-3.38-7.16-6.95-9.69-11.18a.08.08,0,0,1,.12-.09A117,117,0,0,0,84.3,288c-.61-3.62-1.33-7.18-2.19-10.69l-.68-.79c-.15-.18.1-.43.25-.26l.21.23a125.33,125.33,0,0,0-4.46-14.18c-2.18-2.59-4.61-4.83-6.19-7.95a.07.07,0,1,1,.11-.07c1.27,1.79,2.51,3.58,4,5.24.58.66,1.21,1.28,1.8,1.92a108.43,108.43,0,0,0-7-14.57A.19.19,0,0,1,70.44,246.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.17,263.78c2.76,3.72,5.9,7.26,8.47,11.1.07.11-.09.22-.18.14-3.29-3.09-6.08-7.32-8.48-11.13C71.91,263.77,72.09,263.68,72.17,263.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,275.74l.11.12c.09.08,0,.21-.12.13l-.12-.12C80.82,275.79,81,275.66,81,275.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,273.33a42.5,42.5,0,0,0,9,21.14,22.3,22.3,0,0,0,7.3,5.7c3.17,1.57,6.48,3.37,9.75,4.66a63.91,63.91,0,0,1,3.46,12.26c.1-.36.21-.73.31-1.08C84.8,298,73.12,282.52,58.18,272.62A.73.73,0,0,0,57.06,273.33Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,278.66c-.11-.09,0-.28.15-.19a61.07,61.07,0,0,1,19,23.46c.11.25-.23.46-.37.22-.7-1.22-1.41-2.4-2.13-3.57h0c-3.41-.65-6.64-3-9.17-5.33-.07-.06,0-.16.1-.1a20.61,20.61,0,0,0,4.32,3,45.87,45.87,0,0,0,4.33,1.72c-1.26-2-2.58-3.93-3.95-5.8a39.62,39.62,0,0,1-10.25-5.76c-.1-.07,0-.23.09-.16a102.79,102.79,0,0,0,9.53,5.09,85.75,85.75,0,0,0-6.73-7.84c-1.16-.61-2.33-1.23-3.45-1.88a.1.1,0,0,1,.07-.18,12.55,12.55,0,0,1,2.65,1.31C65.1,281.32,63.71,280,62.23,278.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.55,284.9a4.57,4.57,0,0,1,.57.41c.06.05,0,.12-.07.09a3.56,3.56,0,0,1-.6-.34C62.35,285,62.44,284.83,62.55,284.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.22 356.18 69.28 356.18 72.58 318.9 73.31 310.68 106.19 310.68 106.92 318.9 110.22 356.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.92 318.9 72.58 318.9 73.31 310.68 106.19 310.68 106.92 318.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.35,
    y: 304.93,
    width: 36.8,
    height: 8.14,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-125"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 356.18 131.79 355.94 212.86 355.85 375 355.68 537.14 355.85 618.21 355.94 699.28 356.18 618.21 356.43 537.14 356.51 375 356.68 212.86 356.51 131.79 356.43 50.72 356.18",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-125"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.23,
    cy: 406.07,
    rx: 244.19,
    ry: 21.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 592.38,
    cy: 450.28,
    rx: 103.16,
    ry: 11.92,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.81,80.62l-1-.17.16-1,1,.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.76,94.43l-.66-.75c.48-.43,1-.88,1.56-1.34l.64.77C428.74,93.57,428.23,94,427.76,94.43Zm3.12-2.58-.61-.79c.53-.4,1.08-.81,1.66-1.22l.58.82C431.94,91.06,431.4,91.46,430.88,91.85Zm3.3-2.33-.55-.84c.56-.37,1.14-.73,1.75-1.1l.51.86Q435,89,434.18,89.52Zm3.46-2.1-.49-.87c.59-.33,1.19-.66,1.81-1l.46.89C438.81,86.77,438.22,87.1,437.64,87.42Zm3.6-1.86-.43-.9c.6-.29,1.23-.58,1.87-.86l.4.92C442.45,85,441.83,85.27,441.24,85.56ZM445,83.94l-.37-.93c.62-.25,1.26-.49,1.92-.73l.34.94C446.19,83.46,445.56,83.69,445,83.94Zm3.8-1.37-.31-1c.65-.2,1.3-.41,2-.6l.28,1C450,82.16,449.38,82.36,448.75,82.57Zm3.89-1.13-.25-1c.65-.17,1.32-.33,2-.48l.22,1C453.94,81.11,453.28,81.27,452.64,81.44Zm3.95-.9-.19-1c.66-.13,1.34-.25,2-.36l.16,1Zm26.23-.4-2-.26.12-1,2,.27Zm-22.23-.25-.14-1q1-.14,2-.24l.11,1Q461.58,79.76,460.59,79.89Zm18.2-.24-2-.17.07-1,2.05.18Zm-14.18-.18-.07-1c.67,0,1.35-.1,2-.13l.05,1C466,79.37,465.28,79.41,464.61,79.47Zm10.13-.12c-.68,0-1.36-.06-2-.08l0-1c.68,0,1.36,0,2.05.08Zm-6.08-.09,0-1,1.9,0h.15v1h-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.59,96.51l-.72-.7.71-.71.7.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.3 89.85 428.2 90.27 425.42 96.2 431.36 93.45 431.78 94.36 423.35 98.26 427.3 89.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.07,184.27l-1,0s0-.34,0-1l1,0C590.08,183.91,590.07,184.27,590.07,184.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.93,181.36c0-.56-.11-1.2-.21-1.91l1-.13c.1.72.17,1.38.22,2Zm-.49-3.82c-.1-.6-.21-1.23-.35-1.9l1-.2c.14.68.26,1.33.36,1.94Zm-.76-3.79c-.14-.6-.29-1.23-.47-1.87l1-.26c.17.66.33,1.29.48,1.9Zm-1-3.73c-.18-.6-.37-1.22-.58-1.85l1-.31c.2.64.4,1.26.58,1.87Zm-1.2-3.68c-.22-.59-.44-1.19-.68-1.81l.93-.36q.36.93.69,1.83Zm-1.41-3.6c-.24-.58-.5-1.18-.77-1.77l.91-.42c.28.61.54,1.21.79,1.8Zm-1.59-3.52c-.27-.58-.56-1.15-.86-1.74l.89-.45c.3.59.59,1.17.87,1.75Zm-1.77-3.44c-.3-.56-.62-1.12-1-1.69l.87-.5q.5.85,1,1.71Zm-1.94-3.35c-.33-.54-.67-1.09-1-1.64l.84-.54c.36.55.71,1.11,1,1.66Zm-2.09-3.25q-.54-.8-1.11-1.59l.81-.58c.39.54.76,1.07,1.12,1.61ZM574.44,146c-.39-.51-.78-1-1.18-1.54l.79-.62,1.19,1.56ZM572.05,143c-.41-.49-.82-1-1.25-1.48l.76-.65q.65.75,1.26,1.5ZM569.53,140c-.43-.47-.86-.95-1.31-1.43l.73-.68c.45.48.89,1,1.32,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.88,137.2l-.7-.71.71-.7.71.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "572.88 138.21 572.45 139.11 566.55 136.26 569.23 142.24 568.32 142.65 564.51 134.16 572.88 138.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.63,115.26a36.38,36.38,0,1,1-19.75-47.59A36.4,36.4,0,0,1,576.63,115.26Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.63,115.26a36.38,36.38,0,1,1-19.75-47.59A36.4,36.4,0,0,1,576.63,115.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M530.19,132.56a33.78,33.78,0,1,1,44-18.3A33.76,33.76,0,0,1,530.19,132.56Zm40.62-19.12A30.32,30.32,0,1,0,530.63,129,30.33,30.33,0,0,0,570.81,113.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M551,81.57l3.22,1.32-.38.92c-.52,1.26-1,2.52-1.56,3.76-.2.46-.08.64.35.89a27.78,27.78,0,0,1,3.64,2.38c2.84,2.41,3.4,5.54,1.75,8.88a19,19,0,0,1-1,1.76,5.32,5.32,0,0,1-4.14,2.34l-1.3.11c.44.44.85.8,1.21,1.21a7.23,7.23,0,0,1,1.42,7.9,10.54,10.54,0,0,1-2.12,3.65,7,7,0,0,1-5,2.25,16.55,16.55,0,0,1-6.42-1.22c-.49-.17-.71-.14-.91.38-.48,1.25-1,2.46-1.54,3.7-.13.3-.28.44-.6.31L534.84,121l.47-1.16c.43-1,.85-2.1,1.3-3.13.15-.36.12-.56-.28-.7-.61-.22-1.2-.49-1.87-.76-.66,1.62-1.3,3.17-2,4.75l-3.22-1.32c.65-1.58,1.28-3.13,1.94-4.75l-8-3.28,2.22-5.41,2.36,1c2.54-6.21,5.06-12.35,7.61-18.55l-2.34-1,2.21-5.39,7.94,3.26c.74-1.79,1.44-3.51,2.16-5.26l3.2,1.31-2.13,5.19,2.37,1C549.56,85,550.26,83.34,551,81.57Zm-9.38,21.64c-.53-.21-1.07-.42-1.59-.66-.35-.15-.52-.06-.65.28q-1.3,3.23-2.64,6.43c-.18.41-.05.58.33.73.93.36,1.85.76,2.79,1.13a3.66,3.66,0,0,0,4.69-1.56,3.8,3.8,0,0,0-1.85-5.9Zm1.18-8.72c-.38.92-.74,1.83-1.13,2.74-.13.3-.1.49.24.62,1,.37,1.93.79,2.93,1.12a2.3,2.3,0,0,0,2.74-1,8,8,0,0,0,.93-1.93,2.89,2.89,0,0,0-1.79-3.7c-.71-.3-1.44-.57-2.16-.89-.34-.16-.51-.07-.65.27C543.53,92.68,543.15,93.58,542.78,94.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M571,89.63a30.15,30.15,0,0,1,2.58,11.59A30.78,30.78,0,0,1,571.41,113a30,30,0,0,1-6.58,10,30.33,30.33,0,0,1-21.73,9.07,30,30,0,0,1-11.76-2.38,30.58,30.58,0,0,1-9.88-6.73A30.12,30.12,0,0,1,515,113a30.51,30.51,0,0,0,28.05,18.23,30.21,30.21,0,0,0,11.42-2.35,29.9,29.9,0,0,0,9.71-6.46A30.53,30.53,0,0,0,571,89.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.87,112.84a30,30,0,0,1-2.55-11.61,30.76,30.76,0,0,1,2.2-11.75,30.28,30.28,0,0,1,6.61-10,30.35,30.35,0,0,1,21.77-9,30.14,30.14,0,0,1,11.74,2.41,30.63,30.63,0,0,1,9.86,6.76,30.11,30.11,0,0,1,6.39,10,30.48,30.48,0,0,0-28-18.32,30.58,30.58,0,0,0-21.14,8.74,30.51,30.51,0,0,0-6.88,32.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.1,86.68c.15-.46.32-.92.48-1.38s.33-.91.5-1.36l1-2.73.07-.18.19.07q4,1.56,8,3.26l-.26.11,1.15-2.6.59-1.29c.19-.43.4-.86.6-1.29-.15.45-.31.9-.47,1.34L544.45,82l-1,2.66-.07.18-.19-.07q-4-1.56-7.95-3.26l.27-.11L534.32,84c-.19.45-.4.89-.6,1.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.25,110.63c.33-.91.68-1.82,1-2.74s.7-1.82,1.05-2.73l.06-.14.15.06,2.37.92-.26.12,1.87-4.65c.63-1.56,1.29-3.09,1.92-4.64s1.31-3.07,2-4.61,1.34-3.06,2-4.58c-.58,1.57-1.16,3.14-1.77,4.69s-1.21,3.12-1.84,4.67-1.24,3.1-1.88,4.64L528,106.27l-.08.19-.19-.08-2.34-1,.21-.08c-.39.89-.77,1.79-1.17,2.68S523.66,109.75,523.25,110.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.05,110c.53.16,1.05.35,1.58.52l1.56.57a3.54,3.54,0,0,0,3-.4,4.21,4.21,0,0,0,1.74-2.54,4.07,4.07,0,0,0,.11-1.59,3.79,3.79,0,0,0-.51-1.55,3.84,3.84,0,0,1,.76,3.22,4.27,4.27,0,0,1-1.84,2.86,3.69,3.69,0,0,1-3.38.34C539,111,538,110.5,537.05,110Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,97.9c.88.25,1.77.56,2.6.85a2.75,2.75,0,0,0,2.37-.57A4,4,0,0,0,548.26,96a4.43,4.43,0,0,0-.16-2.64,3.92,3.92,0,0,1,.52,2.71,4,4,0,0,1-1.35,2.49,3,3,0,0,1-2.78.56C543.62,98.74,542.82,98.33,542,97.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.23,113.91a13.85,13.85,0,0,1-1.94,4.75,12.37,12.37,0,0,1,.75-2.47A13,13,0,0,1,531.23,113.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.65,116.21a13.81,13.81,0,0,1-1.94,4.72,13.81,13.81,0,0,1,1.94-4.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557,109.94A36.38,36.38,0,1,1,520.7,73.41,36.38,36.38,0,0,1,557,109.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520.64,143.57a33.78,33.78,0,1,1,33.79-33.64A33.75,33.75,0,0,1,520.64,143.57ZM551,110.46a30.32,30.32,0,1,0-31.27,29.63A30.34,30.34,0,0,0,551,110.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.52,88.5H524v1c0,1.35,0,2.71,0,4.06,0,.51.17.63.66.7a25.37,25.37,0,0,1,4.27.82c3.54,1.15,5.25,3.82,5,7.54a15.08,15.08,0,0,1-.26,2,5.33,5.33,0,0,1-2.94,3.73c-.36.2-.72.37-1.16.59.57.24,1.09.43,1.58.67a7.25,7.25,0,0,1,4.32,6.77,10.63,10.63,0,0,1-.59,4.18,7,7,0,0,1-3.77,4,16.61,16.61,0,0,1-6.4,1.31c-.52,0-.71.14-.7.7,0,1.33,0,2.66,0,4,0,.33-.09.51-.44.51h-3v-1.25c0-1.13,0-2.26,0-3.39,0-.38-.1-.56-.52-.54-.65,0-1.3,0-2,0v5.14h-3.49v-5.14h-8.63v-5.85h2.55V100h-2.53V94.2h8.59V88.51H518v5.61h2.56Zm-.47,23.59c-.57,0-1.15,0-1.72,0-.38,0-.5.13-.5.5,0,2.31,0,4.63,0,7,0,.45.17.55.58.55,1,0,2,0,3,0a3.67,3.67,0,0,0,3.76-3.21,3.81,3.81,0,0,0-4-4.77Zm-2.22-8.51c0,1,0,2,0,3,0,.33.09.5.45.49,1.05,0,2.09,0,3.14-.08a2.28,2.28,0,0,0,2.17-1.93,7.62,7.62,0,0,0,.13-2.13,2.89,2.89,0,0,0-3.05-2.75c-.78,0-1.56,0-2.34,0-.38,0-.51.13-.5.49C517.84,101.61,517.83,102.59,517.83,103.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M542.09,88.37a29.64,29.64,0,0,1,6.79,9.75,30.4,30.4,0,0,1-16.49,40.1,30,30,0,0,1-11.78,2.26A30.66,30.66,0,0,1,508.92,138a30.09,30.09,0,0,1-9.74-6.82,30.46,30.46,0,0,0,32.88,6.22,30.43,30.43,0,0,0,16.19-16.16,30.44,30.44,0,0,0-6.16-32.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,131.14a30,30,0,0,1-6.76-9.77,30.69,30.69,0,0,1-2.42-11.7,30.1,30.1,0,0,1,2.32-11.77,30.36,30.36,0,0,1,16.72-16.58,30,30,0,0,1,11.78-2.23A30.66,30.66,0,0,1,532.3,81.6,30.07,30.07,0,0,1,542,88.44a30.52,30.52,0,0,0-32.85-6.32,30.09,30.09,0,0,0-9.69,6.48,29.73,29.73,0,0,0-6.56,9.64,30.53,30.53,0,0,0,6.06,32.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.91,100c0-.48-.05-1-.07-1.46s0-1-.06-1.45l-.07-2.91V94h.21c2.87,0,5.73,0,8.59,0l-.2.2.07-2.85.06-1.42c0-.47,0-1,.07-1.42,0,.47,0,.95.07,1.42l.06,1.42.07,2.85v.19h-.21q-4.29.07-8.59,0l.21-.2L506,97.11c0,.48,0,1-.06,1.45S505.94,99.54,505.91,100Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.89,125.92c0-1-.07-2-.1-2.92s0-2-.06-2.93v-.15h.16l2.55,0-.2.2,0-5c0-1.67,0-3.34,0-5s0-3.34.07-5,.08-3.34.14-5q.1,2.51.15,5c0,1.68.06,3.35.07,5s0,3.34,0,5l0,5v.21h-.2l-2.55,0,.16-.16c0,1,0,2-.06,2.93S505.94,125,505.89,125.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.41,120.09c.55-.06,1.11-.08,1.66-.12l1.67-.07a3.51,3.51,0,0,0,2.61-1.5,4.22,4.22,0,0,0,.65-3,4.14,4.14,0,0,0-.51-1.52,3.68,3.68,0,0,0-1.06-1.23,3.84,3.84,0,0,1,1.93,2.68,4.32,4.32,0,0,1-.61,3.35,3.73,3.73,0,0,1-3,1.6C520.63,120.23,519.52,120.18,518.41,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.41,107c.91-.1,1.84-.15,2.73-.2a2.75,2.75,0,0,0,2-1.42,4,4,0,0,0,.37-2.52,4.51,4.51,0,0,0-1.15-2.38,4.17,4.17,0,0,1,1.2,5.12,3,3,0,0,1-2.36,1.58C520.22,107.19,519.33,107.11,518.41,107Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.52,125.92a12.42,12.42,0,0,1,.24,2.57,11.83,11.83,0,0,1-.24,2.57,13.88,13.88,0,0,1,0-5.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.4,126a12.24,12.24,0,0,1,.24,2.55,11.59,11.59,0,0,1-.24,2.55,13.67,13.67,0,0,1,0-5.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "468.05 432.86 467.99 431.86 468.98 431.8 469.06 432.79 468.05 432.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,432.62l-.09-1c.68-.06,1.35-.13,2-.21l.11,1Q472.14,432.53,471.1,432.62Zm4.07-.46-.13-1,2-.3.16,1Zm4.05-.66-.18-1,2-.4.21,1C480.57,431.24,479.9,431.38,479.22,431.5Zm4-.85-.23-1,2-.49.26,1C484.58,430.33,483.91,430.49,483.24,430.65Zm4-1-.29-1c.66-.19,1.3-.39,1.94-.59l.31.95C488.52,429.21,487.87,429.41,487.21,429.6Zm3.9-1.26-.33-.94,1.9-.71.36.94Zm3.84-1.48-.39-.92,1.85-.81.42.91Zm3.73-1.7-.44-.9c.62-.3,1.22-.61,1.81-.92l.46.88C499.92,424.54,499.31,424.85,498.68,425.16Zm3.64-1.93-.5-.87c.6-.33,1.18-.68,1.74-1l.52.86C503.51,422.54,502.92,422.89,502.32,423.23Zm3.5-2.14-.55-.84c.57-.38,1.13-.76,1.67-1.14l.58.82C507,420.32,506.4,420.7,505.82,421.09Zm3.36-2.37-.6-.8c.55-.41,1.08-.83,1.59-1.25l.63.78C510.28,417.88,509.74,418.3,509.18,418.72Zm3.2-2.59-.65-.75c.52-.45,1-.9,1.51-1.35l.68.73C513.42,415.22,512.91,415.68,512.38,416.13Zm3-2.79-.7-.71c.49-.49,1-1,1.41-1.45l.73.69C516.38,412.35,515.91,412.84,515.4,413.34Zm2.83-3-.76-.66c.47-.52.9-1,1.31-1.54l.77.63C519.14,409.28,518.7,409.81,518.23,410.34Zm2.6-3.19-.8-.6c.43-.58.82-1.12,1.18-1.64l.82.57C521.67,406,521.26,406.56,520.83,407.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.18,403.74l-.85-.53.52-.84.86.51C523.55,403.15,523.37,403.44,523.18,403.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.74 409.25 521.76 409.05 523.08 402.63 517.94 406.69 517.32 405.91 524.62 400.14 522.74 409.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.21,382.54c-.27-.61-.4-1-.4-1l.94-.35s.12.32.38.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.85,416.54l-1.76-.84.44-.9,1.74.83Zm-3.51-1.72c-.59-.3-1.17-.61-1.73-.91l.47-.88,1.71.9ZM357.9,413c-.58-.32-1.14-.65-1.69-1l.51-.85c.55.33,1.1.65,1.67,1Zm-3.36-2c-.56-.36-1.11-.71-1.64-1.07l.55-.83,1.62,1Zm-3.26-2.17c-.54-.38-1.07-.76-1.59-1.15l.59-.8c.51.38,1,.75,1.57,1.13Zm-3.16-2.32-1.53-1.22.63-.78c.49.4,1,.8,1.52,1.2Zm-3-2.48c-.51-.43-1-.86-1.48-1.29l.67-.75c.48.43,1,.86,1.46,1.28Zm-2.91-2.62c-.49-.46-.95-.92-1.41-1.37l.71-.71,1.38,1.35Zm-2.77-2.78c-.46-.48-.91-1-1.33-1.44l.74-.67c.42.47.86,1,1.31,1.43Zm-2.62-2.91c-.44-.52-.85-1-1.25-1.52l.78-.62c.39.49.8,1,1.23,1.49Zm-2.46-3.07c-.4-.54-.79-1.06-1.15-1.58l.81-.58q.54.76,1.14,1.56Zm-2.26-3.2c-.39-.57-.74-1.13-1.06-1.65l.85-.53c.32.52.66,1.06,1,1.63ZM330,386c-.36-.63-.68-1.21-.94-1.73l.89-.45c.26.5.56,1.07.92,1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.58 417.74 366.65 417.34 367.05 416.43 367.97 416.82 367.58 417.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.11 417.76 361.17 416.76 367.71 417.18 362.97 412.65 363.66 411.93 370.39 418.35 361.11 417.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.26,419.13a36.38,36.38,0,1,1-23.42-45.89A36.39,36.39,0,0,1,470.26,419.13Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.26,419.13a36.38,36.38,0,1,1-23.42-45.89A36.39,36.39,0,0,1,470.26,419.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33,440a33.78,33.78,0,1,1,42.46-21.7A33.77,33.77,0,0,1,425.33,440Zm39-22.26a30.32,30.32,0,1,0-38.83,18.65A30.35,30.35,0,0,0,464.32,417.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M442.05,387.56l3.31,1.06-.31.95c-.41,1.29-.81,2.59-1.25,3.87-.17.48,0,.65.41.87a26.56,26.56,0,0,1,3.82,2.08c3,2.18,3.83,5.25,2.44,8.71a17.13,17.13,0,0,1-.86,1.84,5.34,5.34,0,0,1-3.94,2.66l-1.29.2c.47.41.91.74,1.3,1.12a7.24,7.24,0,0,1,2,7.76,10.67,10.67,0,0,1-1.83,3.81,7,7,0,0,1-4.81,2.63,16.62,16.62,0,0,1-6.5-.7c-.5-.14-.72-.09-.87.44-.38,1.28-.84,2.54-1.25,3.81-.1.31-.24.46-.57.36l-2.84-.92c.14-.42.26-.81.38-1.19.35-1.07.68-2.15,1-3.22.13-.37.08-.57-.32-.68-.63-.17-1.24-.39-1.93-.61-.53,1.67-1,3.26-1.57,4.89l-3.32-1.06c.52-1.63,1-3.22,1.57-4.89l-8.22-2.64c.61-1.88,1.19-3.69,1.79-5.56l2.43.77L427,394.83l-2.41-.77c.6-1.86,1.18-3.67,1.78-5.55l8.18,2.63,1.74-5.42,3.29,1.06c-.56,1.76-1.13,3.52-1.71,5.34l2.43.78C440.9,391.13,441.46,389.38,442.05,387.56Zm-7.66,22.31c-.55-.17-1.1-.33-1.64-.53-.35-.13-.51,0-.62.32-.7,2.21-1.4,4.42-2.13,6.62-.14.43,0,.59.39.7,1,.29,1.91.62,2.87.91a3.67,3.67,0,0,0,4.56-1.91,3.81,3.81,0,0,0-2.32-5.75Zm.49-8.78c-.3.94-.59,1.88-.9,2.81-.11.31-.06.5.28.6,1,.29,2,.64,3,.89a2.28,2.28,0,0,0,2.66-1.17,7.74,7.74,0,0,0,.77-2,2.88,2.88,0,0,0-2.07-3.54c-.74-.25-1.49-.46-2.22-.73-.36-.12-.52,0-.63.33C435.5,399.22,435.19,400.15,434.88,401.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M462.63,394a30,30,0,0,1,3.49,11.36,30.71,30.71,0,0,1-1.24,11.89,30.22,30.22,0,0,1-5.77,10.51,30.33,30.33,0,0,1-21,10.74,30,30,0,0,1-11.9-1.44,30.77,30.77,0,0,1-10.38-5.94,30.08,30.08,0,0,1-7.19-9.46,30.45,30.45,0,0,0,29.4,16,30.59,30.59,0,0,0,20.37-10.43,30.53,30.53,0,0,0,4.18-33.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,421.57a30,30,0,0,1-3.45-11.37,30.71,30.71,0,0,1,1.28-11.89,30,30,0,0,1,5.8-10.49,30.3,30.3,0,0,1,21-10.68,30.21,30.21,0,0,1,11.9,1.48,30.62,30.62,0,0,1,10.35,6,29.89,29.89,0,0,1,7.16,9.48A30.47,30.47,0,0,0,433.18,378a30.51,30.51,0,0,0-20.39,10.37,30.5,30.5,0,0,0-4.29,33.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.62,394.06c.12-.47.25-.94.38-1.41s.25-.94.39-1.4l.82-2.8.05-.19.2.06c2.74.83,5.47,1.7,8.18,2.63l-.25.13.94-2.69.49-1.33c.16-.45.32-.89.5-1.34-.12.46-.24.92-.37,1.38l-.38,1.37-.8,2.73,0,.19-.2-.06q-4.11-1.24-8.18-2.62l.25-.14-1,2.75c-.15.46-.33.92-.5,1.37S424.8,393.6,424.62,394.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.68,418.71c.26-.94.54-1.87.8-2.81s.56-1.87.84-2.8l0-.15.16,0,2.44.74-.26.13,1.51-4.78c.5-1.59,1-3.18,1.55-4.77s1.06-3.17,1.6-4.75,1.1-3.16,1.67-4.73c-.45,1.61-.91,3.22-1.4,4.82s-.95,3.2-1.46,4.79-1,3.19-1.52,4.78L421.09,414l-.06.19-.19-.06-2.42-.82.2-.11c-.32.93-.62,1.85-.95,2.77S417,417.8,416.68,418.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.39,417c.54.12,1.08.27,1.62.4l1.6.44a3.5,3.5,0,0,0,2.95-.63,4.43,4.43,0,0,0,1.52-4.26,4,4,0,0,0-.63-1.51,3.87,3.87,0,0,1,1,3.15,4.33,4.33,0,0,1-1.61,3,3.7,3.7,0,0,1-3.35.59C432.45,417.8,431.41,417.42,430.39,417Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.38,404.54c.89.19,1.8.42,2.66.65a2.75,2.75,0,0,0,2.31-.76,4,4,0,0,0,1.12-2.28,4.58,4.58,0,0,0-.36-2.62,3.94,3.94,0,0,1,.72,2.66,4,4,0,0,1-1.15,2.59,3,3,0,0,1-2.73.77C436.06,405.25,435.23,404.91,434.38,404.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.9,421.35a14,14,0,0,1-1.57,4.89,11.94,11.94,0,0,1,.56-2.52A12.6,12.6,0,0,1,424.9,421.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.48,423.21a13.5,13.5,0,0,1-1.56,4.86,12.39,12.39,0,0,1,.55-2.5A12.52,12.52,0,0,1,430.48,423.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.81,415.58A36.38,36.38,0,1,1,409,385.45,36.39,36.39,0,0,1,450.81,415.58Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M420.37,454.69A33.78,33.78,0,1,1,448.24,416,33.77,33.77,0,0,1,420.37,454.69Zm24.53-37.61a30.32,30.32,0,1,0-26,34.33A30.34,30.34,0,0,0,444.9,417.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M411.29,400.37l3.43-.57.16,1c.22,1.34.46,2.67.65,4,.08.5.27.58.77.58a25.25,25.25,0,0,1,4.35.11c3.68.56,5.8,2.92,6.14,6.63a17.31,17.31,0,0,1,.08,2,5.35,5.35,0,0,1-2.3,4.17c-.32.25-.65.48-1.05.77.61.14,1.15.24,1.67.4a7.25,7.25,0,0,1,5.36,6,10.53,10.53,0,0,1,.1,4.22,6.88,6.88,0,0,1-3.07,4.54,16.46,16.46,0,0,1-6.1,2.34c-.51.1-.68.25-.58.8.25,1.31.41,2.64.63,3.95.05.33,0,.53-.35.58l-2.94.49c-.07-.44-.14-.84-.2-1.24-.19-1.11-.38-2.22-.55-3.34-.05-.38-.18-.54-.6-.45-.63.13-1.28.22-2,.33.29,1.73.56,3.38.84,5.07l-3.44.57c-.28-1.69-.55-3.34-.84-5.07L403,439.67c-.33-1.95-.63-3.83-.95-5.77l2.51-.42-3.26-19.78-2.5.41c-.31-1.93-.62-3.8-.94-5.75l8.47-1.39c-.31-1.91-.62-3.74-.92-5.62l3.41-.56.91,5.53,2.52-.41C411.9,404.07,411.6,402.26,411.29,400.37Zm3.38,23.35c-.57.09-1.13.2-1.7.28-.38,0-.47.2-.41.57.38,2.28.77,4.57,1.13,6.86.07.44.26.52.66.44,1-.18,2-.32,3-.5a3.67,3.67,0,0,0,3.18-3.78,3.81,3.81,0,0,0-4.68-4.06Zm-3.57-8c.16,1,.32,1.94.47,2.92.05.32.18.47.53.4,1-.2,2.06-.34,3.08-.58a2.28,2.28,0,0,0,1.83-2.26,7.6,7.6,0,0,0-.22-2.13,2.89,2.89,0,0,0-3.46-2.21c-.77.12-1.54.27-2.31.37-.38.06-.48.22-.41.58C410.78,413.74,410.93,414.71,411.1,415.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,396.72a30,30,0,0,1,8.28,8.52,30.54,30.54,0,0,1,4.33,11.14,30.09,30.09,0,0,1-.34,12,30.32,30.32,0,0,1-13.74,19.12,30,30,0,0,1-11.25,4.15,30.77,30.77,0,0,1-11.94-.54A29.85,29.85,0,0,1,397.19,446a30.49,30.49,0,0,0,33.44.79A30.49,30.49,0,0,0,444,428.17a30.56,30.56,0,0,0-11.43-31.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,445.94a29.88,29.88,0,0,1-8.26-8.54,30.58,30.58,0,0,1-4.29-11.15,30.09,30.09,0,0,1,.37-12,30.33,30.33,0,0,1,13.8-19.08,30.17,30.17,0,0,1,11.26-4.11,29.82,29.82,0,0,1,22.64,5.74,30.48,30.48,0,0,0-33.44-.89,30.53,30.53,0,0,0-13.41,18.54A30.47,30.47,0,0,0,397,445.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.75,414.11c-.11-.47-.21-.95-.3-1.43s-.21-.95-.3-1.42l-.54-2.86,0-.2.2,0c2.82-.51,5.64-1,8.48-1.39l-.17.23-.39-2.82-.17-1.41c-.06-.47-.12-.94-.16-1.42l.3,1.4.28,1.39.54,2.79,0,.2-.21,0c-2.81.52-5.64,1-8.47,1.4l.17-.23.4,2.89c.07.48.12,1,.18,1.44S398.7,413.63,398.75,414.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,439.67c-.21-1-.39-1.91-.58-2.87s-.35-1.92-.53-2.87l0-.16.16,0,2.51-.46-.17.24-.85-4.94c-.28-1.65-.52-3.3-.79-4.95s-.51-3.31-.75-5-.46-3.31-.67-5c.33,1.64.66,3.28,1,4.92s.61,3.29.88,4.94.58,3.29.84,4.94l.78,4.95,0,.21-.2,0-2.52.37.13-.19c.14,1,.29,1.93.42,2.9S402.83,438.7,403,439.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.35,431.87c.54-.14,1.08-.25,1.62-.38l1.63-.34a3.56,3.56,0,0,0,2.34-1.91,4.24,4.24,0,0,0,.14-3.08,4.06,4.06,0,0,0-.74-1.41,4,4,0,0,0-1.25-1.05,3.87,3.87,0,0,1,2.34,2.34,4.34,4.34,0,0,1-.06,3.41,3.69,3.69,0,0,1-2.71,2.06C416.56,431.66,415.46,431.79,414.35,431.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.22,419c.88-.24,1.8-.45,2.66-.64a2.72,2.72,0,0,0,1.72-1.73,4,4,0,0,0-.05-2.54,4.54,4.54,0,0,0-1.52-2.16,3.93,3.93,0,0,1,1.86,2,4,4,0,0,1,.16,2.83,3,3,0,0,1-2.08,1.94C414,418.85,413.15,418.92,412.22,419Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.46,438.26a12.47,12.47,0,0,1,.66,2.5,12.17,12.17,0,0,1,.18,2.57,11.57,11.57,0,0,1-.65-2.49A12.31,12.31,0,0,1,411.46,438.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.28,437.38a13.79,13.79,0,0,1,.83,5,13.25,13.25,0,0,1-.83-5Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M657.3,189.34H542.08a11.77,11.77,0,0,0-11.66,11.87v237.2a11.78,11.78,0,0,0,11.66,11.87H657.3A11.78,11.78,0,0,0,669,438.41V201.21A11.77,11.77,0,0,0,657.3,189.34Zm4.38,241.73c0,6.25-4.67,11.3-10.44,11.3H548.16c-5.78,0-10.46-5.05-10.46-11.3V210.2c0-12.72,4.68-13.34,10.46-13.34H568.8c1.2,0,2.19,1.36,2.19,3v.73c0,4,2.16,4,4.83,4h47.75c2.68,0,4.83,0,4.83-4v-.73c0-1.69,1-3,2.19-3h20.65c5.77,0,10.44,1.69,10.44,13.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.21,199.67h-13a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.81h13a.8.8,0,0,1,.8.81h0A.8.8,0,0,1,606.21,199.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.69,210.2V431.07c0,6.25-4.68,11.3-10.45,11.3H548.16c-5.78,0-10.45-5.05-10.45-11.3V210.2c0-12.72,4.67-13.34,10.45-13.34h20.65c1.2,0,2.18,1.36,2.18,3v.73c0,4,2.16,4,4.83,4h47.75c2.69,0,4.83,0,4.83-4v-.73c0-1.69,1-3,2.19-3h20.65C657,196.86,661.69,198.55,661.69,210.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.69,210.2v12.89h-124V210.2c0-12.72,4.67-13.34,10.45-13.34h20.65c1.2,0,2.18,1.36,2.18,3v.73c0,4,2.16,4,4.83,4h47.75c2.69,0,4.83,0,4.83-4v-.73c0-1.69,1-3,2.19-3h20.65C657,196.86,661.69,198.55,661.69,210.2Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.24,201.82l-.2.2a.57.57,0,0,1-.11.11,2.73,2.73,0,0,0-3.85,0L561,202l-.2-.19h0a2.73,2.73,0,0,1,.25-.23,3,3,0,0,1,.58-.37,3.11,3.11,0,0,1,.78-.26l.38,0h.34l.27,0a3,3,0,0,1,1.19.4,2.83,2.83,0,0,1,.45.32l.21.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.72,202.76l-.32-.31a2.28,2.28,0,0,1,1.29-.65,2.25,2.25,0,0,1,1.92.64l-.31.32a1.83,1.83,0,0,0-2.58,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564,203.08l-.31.31a.91.91,0,0,0-.66-.28,1,1,0,0,0-.66.28l-.32-.31A1.36,1.36,0,0,1,564,203.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.29,203.67a.29.29,0,0,1-.28.29.29.29,0,0,1,0-.57A.29.29,0,0,1,563.29,203.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M545.79,202.43a.82.82,0,1,1,.82.82A.83.83,0,0,1,545.79,202.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.38,202.43a.82.82,0,1,1,.82.82A.82.82,0,0,1,548.38,202.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,202.43a.82.82,0,1,1,.82.82A.82.82,0,0,1,551,202.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.55,202.43a.83.83,0,1,1,.82.82A.83.83,0,0,1,553.55,202.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.14,202.43a.82.82,0,1,1,1.64,0,.82.82,0,0,1-1.64,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.39,204.22h-6.7v-3.1h6.7Zm-6.35-.35h6v-2.4h-6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.25,
    y: 201.65,
    width: 4.31,
    height: 2.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.39,
    y: 201.84,
    width: 0.59,
    height: 1.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.5,442.28a8.69,8.69,0,0,1-1.26.09H608.85c0-.17-.08-.34-.11-.51s-.11-.48-.16-.72-.11-.54-.17-.8c-6.12-28.49-11.45-62.21-13.3-70.48a145.86,145.86,0,0,1-5.68-17.11c-.09-.31-.17-.63-.26-.95-.64-2.47-1.27-5.1-1.83-7.84-.71-3.44-1.31-7-1.72-10.72,0,0,34.36,0,45.76,0H635l.07.13a84.47,84.47,0,0,1,4.34,10.55c3,8.79,5.74,21.42,1.86,31.6C640.74,376.9,647.55,423.18,652.5,442.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.32,442.37h-1.15c-.44-2.79-.86-5.58-1.31-8.36q-2.46-15.39-4.91-30.79l-.06-.38-.27-1.66c-.09-.58-.19-1.17-.28-1.76-.66-4-1.31-7.94-1.8-11.93-.42-3.37-.94-6.72-1.46-10.08l-.21-1.3c-.24-1.5-.47-3-.7-4.52-.19-1.29-.38-2.59-.55-3.89,0-.27.36-.39.41-.11.53,2.84,1,5.7,1.47,8.55l.21,1.31c.3,1.87.6,3.75.91,5.62.44,2.63,1,5.23,1.45,7.86.24,1.43.47,2.86.7,4.28.09.59.19,1.18.28,1.76s.19,1.14.28,1.71l0,.16q2.49,15.51,4.95,31Q619.3,436.12,620.32,442.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.07,333.24v.13A96.15,96.15,0,0,1,634,344c-1.26,8.29-4,19.9-10,29.44,0,0-2,.75-4.23,1.72a51.13,51.13,0,0,0-4.66,2.21l-.06,0s0,.13,0,.39c-.19,1.78-1,9.47-2,19.15-.14,1.37-.28,2.77-.43,4.21-1.42,14-3.11,30.73-4,40q-.06.64-.12,1.23H566.85c.54-10.31,3.44-59.84,12.7-96.12.21-.8.42-1.6.63-2.38.09-.35.19-.7.29-1.05.39-1.46.8-2.9,1.22-4.31,0,0,0-.07,0-.11l.33-1.09c.43-1.39.87-2.75,1.32-4.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.65,337.53q-.79,3.23-1.49,6.46c-.63,2.91-1.2,5.83-1.73,8.76-1.28,7.06-2.3,14.16-3.21,21.27-1.54,12.15-3,24.32-4.24,36.5q-1.62,15.9-2.49,31.85h-1.08c1.36-21.65,3.71-43.21,6.59-64.72,1.15-8.65,2.43-17.29,4.17-25.85.53-2.61,1.1-5.22,1.72-7.81.52-2.17,1.07-4.33,1.67-6.48A0,0,0,0,1,592.65,337.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.36,342.86a.08.08,0,0,1,.16,0c-.2,2.94-.7,6.15.61,8.92,1.15,2.45,3.35,3.83,5.37,5.48.06,0,0,.15-.08.13-2.69-.81-5.37-2.3-6.42-5.05C578.81,349.28,579.45,345.92,580.36,342.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.77,375.91a49.82,49.82,0,0,1,6.46.22,43,43,0,0,0,6.32-.12,22.22,22.22,0,0,0,3.13-.52c1.07-.25,2.08-.65,3.14-.94a5.75,5.75,0,0,1,2.91.12c1.12.25,2.24.42,3.38.57a32.49,32.49,0,0,0,7.82.2c.1,0,.15.14,0,.16a31.71,31.71,0,0,1-6.66.69,24.42,24.42,0,0,1-3.42-.31,11,11,0,0,0-3.21-.41,31,31,0,0,0-3.13,1,24.41,24.41,0,0,1-3.17.65,33.32,33.32,0,0,1-6.47.2,29.13,29.13,0,0,1-7.21-1.11A.23.23,0,0,1,602.77,375.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,376.91c0,.17,0,.33,0,.5s0,.27,0,.41c-.11,4.18-.56,8.36-.91,12.53q-.36,4.25-.74,8.49c-.14,1.46-.27,2.92-.41,4.38,0,.19,0,.37-.05.56-.84,9-1.64,17.91-2.69,26.84-.3,2.54-.61,5.07-.94,7.61-.16,1.21-.35,2.42-.53,3.63,0,.17,0,.34-.08.51h-.39c.05-.67.1-1.35.14-2,.19-2.65.36-5.3.6-7.94.41-4.47.86-8.95,1.32-13.42.69-6.52,1.34-13,2-19.56.14-1.41.28-2.81.43-4.21.1-1,.2-2,.31-3.07.5-4.9.87-9.84,1.65-14.71,0-.18,0-.35.08-.53A.11.11,0,0,1,615,376.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.67,316.44l-4.2,22.49s49.79.7,61.49-.12c0,0-12.23-47.62-24.8-61.28-6.29-6.82-13.68-6.31-18.38-1.54-1.19,1.21-15.4,20-16.9,27.16C579.58,309.48,583.67,316.44,583.67,316.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.8,324a5.16,5.16,0,0,0-1.19,1.69,5.38,5.38,0,0,0,1.69-1.19,5.72,5.72,0,0,0,1.19-1.69A5.16,5.16,0,0,0,616.8,324Zm-15.27-47.78a5.27,5.27,0,0,0-1.19,1.69,5.7,5.7,0,0,0,1.69-1.18,5.86,5.86,0,0,0,1.19-1.69A5.14,5.14,0,0,0,601.53,276.22Zm-14.46,42.21a5.16,5.16,0,0,0-1.19,1.69,5.16,5.16,0,0,0,1.69-1.19,5.38,5.38,0,0,0,1.19-1.69A5.16,5.16,0,0,0,587.07,318.43Zm3.39,12.65a5.74,5.74,0,0,0-1.7-1.18,5.9,5.9,0,0,0,2.89,2.88A6.11,6.11,0,0,0,590.46,331.08ZM606.75,300a5.4,5.4,0,0,0-1.69-1.18,5.86,5.86,0,0,0,2.88,2.87A5.67,5.67,0,0,0,606.75,300Zm24.57,31a5.38,5.38,0,0,0-2,.36,5.36,5.36,0,0,0,2,.35,5.5,5.5,0,0,0,2-.35A5.51,5.51,0,0,0,631.32,331ZM619.09,306.8a5.72,5.72,0,0,0-2.05.36,5.72,5.72,0,0,0,2.05.36,5.41,5.41,0,0,0,2-.36A5.62,5.62,0,0,0,619.09,306.8Zm-26.56-2.93a5.62,5.62,0,0,0-2,.36,5.62,5.62,0,0,0,2,.36,5.72,5.72,0,0,0,2.05-.36A5.51,5.51,0,0,0,592.53,303.87Zm12.53,26.75a5.67,5.67,0,0,0-2,.36,5.67,5.67,0,0,0,2,.36,5.43,5.43,0,0,0,2-.36A5.63,5.63,0,0,0,605.06,330.62Zm2-45.36a5.63,5.63,0,0,0-2,.36,5.93,5.93,0,0,0,4.07,0A5.62,5.62,0,0,0,607.1,285.26Zm-13.51,1.82a5.78,5.78,0,0,0,0,4.07,5.85,5.85,0,0,0,.36-2A5.62,5.62,0,0,0,593.59,287.08Zm23.82,51.1a4.31,4.31,0,0,0-.28,1h.55A4.81,4.81,0,0,0,617.41,338.18ZM603.72,313.9a6.09,6.09,0,0,0,0,4.07,5.58,5.58,0,0,0,.36-2A5.43,5.43,0,0,0,603.72,313.9Zm26.64,0a5.24,5.24,0,0,0-.36,2,5.38,5.38,0,0,0,.36,2,6.09,6.09,0,0,0,0-4.07Zm-10.55-23.31a6,6,0,0,0,0,4.08,5.63,5.63,0,0,0,.36-2A5.39,5.39,0,0,0,619.81,290.59Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.44,265.63a36.38,36.38,0,1,1-36.33-36.54A36.39,36.39,0,0,1,578.44,265.63Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M542.11,231.69a33.75,33.75,0,0,0-33.36,28.18,33.34,33.34,0,0,0-.46,4.93c0,.12,0,.25,0,.38v.29a33.55,33.55,0,0,0,1.23,9.07c.06.22.12.44.19.66a33.77,33.77,0,0,0,53.13,16.92c.19-.15.39-.3.57-.46a34,34,0,0,0,2.74-2.49c.21-.21.42-.43.62-.65a33.78,33.78,0,0,0-24.65-56.83Zm18,9.46a30.86,30.86,0,0,1,3.34,2.9,3.25,3.25,0,0,1,.26.27,30.27,30.27,0,0,1-.44,42.75l-.6.56a26.56,26.56,0,0,1-2.52,2.11l-.46.34q-1.1.8-2.25,1.47a30.46,30.46,0,0,1-16.39,4.23,29.79,29.79,0,0,1-17.1-6,26.8,26.8,0,0,1-2.33-1.93l-.37-.34a30.86,30.86,0,0,1-5.25-6.51.75.75,0,0,1-.07-.12,29,29,0,0,1-1.76-3.47c-.07-.14-.13-.28-.19-.42a29.82,29.82,0,0,1-2.27-10.63c0-.22,0-.45,0-.68s0-.65,0-1a29.66,29.66,0,0,1,.66-5.54,30.32,30.32,0,0,1,47.37-18.31Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M556.84,272.09a7.24,7.24,0,0,0-4.31-6.77c-.49-.24-1-.42-1.58-.66l1.16-.59a5.34,5.34,0,0,0,2.94-3.74,13.63,13.63,0,0,0,.25-2c.27-3.72-1.44-6.4-5-7.55a27.53,27.53,0,0,0-4.27-.82c-.49-.07-.67-.19-.66-.69,0-1.36,0-2.71,0-4.07v-1h-3.47v5.61h-2.56v-5.6h-3.46v5.68h-8.59v5.83h2.53v20H527.3v5.85h8.63v5.13h3.49V281.6c.66,0,1.26,0,1.85,0h.17a.55.55,0,0,1,.37.09c.12.08.15.23.15.46v.43c0,1,0,2,0,3v1.25h3c.35,0,.44-.19.44-.52,0-1.33,0-2.67,0-4,0-.56.18-.68.7-.7a21.21,21.21,0,0,0,3.29-.34,13,13,0,0,0,3.11-1,7,7,0,0,0,3.77-4A10.4,10.4,0,0,0,556.84,272.09Zm-17.6-12.83c0-1,0-2,0-2.95,0-.37.12-.51.5-.5.78,0,1.56,0,2.34,0a3.18,3.18,0,0,1,1.78.5,2.43,2.43,0,0,1,.32.24.3.3,0,0,1,.08.08,1.38,1.38,0,0,1,.23.26,1.79,1.79,0,0,1,.2.28,1.41,1.41,0,0,1,.13.24,3.42,3.42,0,0,1,.31,1.14,8.09,8.09,0,0,1-.13,2.14,2.29,2.29,0,0,1-2.17,1.93c-1,.07-2,0-3,.07h-.15c-.36,0-.46-.15-.45-.48C539.25,261.23,539.24,260.25,539.24,259.26Zm0,16V275c0-.24,0-.48,0-.72,0-2,0-4,0-6.05,0-.37.12-.51.5-.5.57,0,1.15,0,1.72,0h1.17a4.41,4.41,0,0,1,2.21.54h0l.18.1a3.87,3.87,0,0,1,.45.35,4,4,0,0,1,1.1,3.76,3.66,3.66,0,0,1-3.75,3.22c-.85,0-1.71,0-2.56,0h-.45C539.41,275.78,539.23,275.67,539.24,275.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M563.5,244.05a30,30,0,0,1,6.79,9.75,30.38,30.38,0,0,1-16.49,40.1A30.17,30.17,0,0,1,542,296.17a30.63,30.63,0,0,1-11.69-2.48,30.06,30.06,0,0,1-9.74-6.81,30.51,30.51,0,0,0,32.88,6.22A30.16,30.16,0,0,0,572,265.5,30.68,30.68,0,0,0,563.5,244.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.38,286.83a30.08,30.08,0,0,1-6.76-9.78,30.66,30.66,0,0,1-2.42-11.7,30,30,0,0,1,2.32-11.76A30.42,30.42,0,0,1,530.24,237,29.94,29.94,0,0,1,542,234.78a30.47,30.47,0,0,1,11.69,2.51,29.91,29.91,0,0,1,9.71,6.84,30.47,30.47,0,0,0-32.85-6.32,30.59,30.59,0,0,0-16.25,16.11,30.55,30.55,0,0,0,6.06,32.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.32,255.71c0-.49-.05-1-.07-1.46s0-1-.06-1.46l-.07-2.91v-.2h.21c2.86-.05,5.73-.05,8.59,0l-.2.2.07-2.84.06-1.42c0-.48,0-1,.07-1.43,0,.48.05.95.07,1.43L536,247l.07,2.84v.2h-.21c-2.86,0-5.73,0-8.59,0l.2-.2-.07,2.91c0,.49,0,1-.06,1.46S527.35,255.22,527.32,255.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.3,281.61c0-1-.07-1.95-.1-2.93s0-1.95-.06-2.92v-.16h.16l2.55,0-.2.2,0-5c0-1.68,0-3.35,0-5s0-3.34.07-5,.08-3.34.14-5q.1,2.5.15,5c0,1.67.06,3.34.06,5s0,3.34,0,5l0,5V276h-.2l-2.55,0,.16-.16c0,1,0,1.95-.06,2.92S527.34,280.63,527.3,281.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.82,275.77c.55,0,1.11-.08,1.66-.12l1.67-.06a3.55,3.55,0,0,0,2.61-1.51,4.21,4.21,0,0,0,.65-3,4,4,0,0,0-.51-1.51,3.81,3.81,0,0,0-1.06-1.24,3.86,3.86,0,0,1,1.93,2.69,4.29,4.29,0,0,1-.62,3.35,3.69,3.69,0,0,1-3,1.59C542,275.92,540.93,275.87,539.82,275.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.82,262.7c.91-.09,1.84-.15,2.73-.19a2.76,2.76,0,0,0,2-1.43,3.94,3.94,0,0,0,.36-2.52,4.53,4.53,0,0,0-1.14-2.38,4.18,4.18,0,0,1,1.2,5.13,3,3,0,0,1-2.36,1.57C541.63,262.87,540.74,262.79,539.82,262.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.93,281.61a12.33,12.33,0,0,1,.24,2.56,11.77,11.77,0,0,1-.24,2.57,13.83,13.83,0,0,1,0-5.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.81,281.68a13.67,13.67,0,0,1,0,5.1,13.67,13.67,0,0,1,0-5.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M610,274c-.3,1-5.52,7.1-10,6.57-1.48-.18-.87-8.28-.87-8.28l-.09-.61-1.28-8.52,10.3-5.62,1.48-.73s.2,2.35.42,5.28c0,.14,0,.27,0,.42s0,.32,0,.48c0,.43.07.88.1,1.33s0,.67.06,1,0,.71,0,1.07A56.64,56.64,0,0,1,610,274Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.9,262.12A17.34,17.34,0,0,1,599,271.71l-1.28-8.52,10.3-5.62,1.48-.73S609.68,259.19,609.9,262.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.59,245.9c-6.82,13.49.39,19.21,3.4,20.56,2.7,1.21,11.81,5.53,20-7.19s4-20.15-1.83-23.51S594.4,232.4,587.59,245.9Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.73,243.32a8.73,8.73,0,0,0,1,.19,1.67,1.67,0,0,0,1.08,0,.54.54,0,0,0,.26-.61,1.36,1.36,0,0,0-1.09-.8,1.94,1.94,0,0,0-1.4.17A.57.57,0,0,0,589.73,243.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.52,247.59a10.06,10.06,0,0,1-.86-.59c-.33-.24-.61-.39-.76-.78a.53.53,0,0,1,.26-.6,1.33,1.33,0,0,1,1.33.22,2,2,0,0,1,.86,1.11A.57.57,0,0,1,598.52,247.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,250.16s.06.07,0,.11c-.45.93-.81,2.07-.1,2.76,0,0,0,.07,0,.05C594,252.47,594.45,251,595,250.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.3,249.55c1.56.56.32,3.65-1.12,3.13S595,249.08,596.3,249.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.84,250c.2.28.34.7.65.86s.78,0,1.15-.23c0,0,.05,0,0,0-.22.6-.69,1.11-1.36.94a1.24,1.24,0,0,1-.73-1.49C596.6,250,596.76,249.84,596.84,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.1,247.56s-.09,0-.1.06c-.35,1-.91,2-1.9,2,0,0-.05,0,0,.06C589.2,249.94,589.93,248.54,590.1,247.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.64,246.23c-1.49-.73-2.83,2.32-1.44,3S590.89,246.83,589.64,246.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.92,246.15c-.31,0-.68.24-1,.14s-.45-.57-.52-1c0,0,0,0-.06,0a1.24,1.24,0,0,0,.16,1.62c.47.32,1.06,0,1.45-.53C589.05,246.33,589,246.13,588.92,246.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.08,257.54c-.32.14-.66.38-1,.28a2.71,2.71,0,0,1-1-.61,0,0,0,0,0-.06,0,1.39,1.39,0,0,0,1.05,1,1.09,1.09,0,0,0,1.06-.6C592.19,257.56,592.12,257.52,592.08,257.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.53,252.45a22.05,22.05,0,0,0-1.06,2c0,.06.12.16.34.27h0a3.44,3.44,0,0,0,3.58.09c.08,0,0-.15-.06-.13a5.18,5.18,0,0,1-3.25-.38c0-.2,1.42-2.24,1.32-2.3a6.33,6.33,0,0,0-1.67-.28c1.56-2.84,3.56-5.4,5.07-8.25a.1.1,0,0,0-.16-.11,52.8,52.8,0,0,0-5.83,8.64C587.63,252.38,589.21,252.45,589.53,252.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.08,254.23a4.17,4.17,0,0,0,.84,2,1.84,1.84,0,0,0,1,.62c.83.22,1.22-.44,1.41-1.09a4.69,4.69,0,0,0,.16-1A5.45,5.45,0,0,1,589.08,254.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.92,256.2a1.84,1.84,0,0,0,1,.62c.83.22,1.22-.44,1.41-1.09A2,2,0,0,0,589.92,256.2Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.58,261c-2.6-1.86,1.48-7.94,1.48-7.94s-3.85-3.93-3.58-8.22c0,0-.6,3.47.39,5.75.16.39-8.2-6.82-4.22-14.3,0,0-6.09,5.87-11.16,4.4-.25-.08,4.93-5.78,7.27-6.31A17.84,17.84,0,0,1,613,238.12c5,4.67,4.52,13,3.27,15.68C613.84,259.06,608.81,261.88,607.58,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.48,250.53c-4.76-3.65-6.47-9.51-3.37-14.81a.14.14,0,0,0-.22-.15c-4.22,4.62-1.33,12.19,3.57,15.08C605.58,250.72,605.59,250.62,605.48,250.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.76,260.71c-1.7-3.23-.26-6.19,1.44-9,0-.09-.08-.18-.14-.1-1.9,2.63-3.7,6.23-1.55,9.3A.15.15,0,0,0,607.76,260.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.33,235.21s0-.06-.05,0c-2.57,2.39-6,7-10.1,5.23a.1.1,0,0,0-.09.17C595.87,242.66,600.68,238.38,602.33,235.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.43,286c-6.17,7.76-31.81,32.07-41.13,30.58-14.61-2.36-34.22-12.7-42.77-16.55-4.64-2.09,13.09-29.17,17.29-25.32,5.48,5,25.63,13.66,28,14.83s19.4-8,32-13.95C609.41,270.59,613.24,276.15,605.43,286Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.27,260.18a4.29,4.29,0,0,0-1.11,4.77,6.4,6.4,0,0,0-3.83,2c-1.66,2,.77,5.52.77,5.52a7.85,7.85,0,0,0-3.69,2.78c-1.4,2.09.56,6,.56,6a6.88,6.88,0,0,0-1.71,4.48c.15,4.42,6,7.8,9.66,10s16.2,4.95,18.53,5.72l15.15-21.76s-6-12.63-19.33-18.26C519.32,259.75,510.83,258,508.27,260.18Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.55,264.67c4.63.74,8.79,2.82,13.05,4.65a.08.08,0,0,1-.06.15c-4.22-1.88-8.76-2.89-13-4.59A.11.11,0,0,1,507.55,264.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.37,272.23a12.06,12.06,0,0,1,3,1.21c1,.5,2,1,3,1.54,2,1.07,4,2.18,5.93,3.35.09.05,0,.19-.06.15-2-1.06-4-2.09-6.06-3.06-1-.49-2-1-3.07-1.44a14.23,14.23,0,0,1-2.85-1.47A.16.16,0,0,1,504.37,272.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.05,281.29a8.33,8.33,0,0,1,2.61,1.23l2.72,1.5c1.81,1,3.63,2,5.48,2.89.09,0,0,.2-.07.15-1.88-.93-3.78-1.83-5.65-2.78l-2.76-1.41a8.16,8.16,0,0,1-2.38-1.49S501,281.28,501.05,281.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.76,285.41l-11,29.7s13.42,4.33,18.34,2.69,27.77-17,38-30.34,3.67-16.59-6.81-11.94-29.93,13.22-30.73,13.22S559.76,285.41,559.76,285.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.54,298a8.25,8.25,0,0,0-2.31.17,7.92,7.92,0,0,0,2.28.43,8.19,8.19,0,0,0,2.31-.17A8.2,8.2,0,0,0,568.54,298Zm26.55-6.11a8.11,8.11,0,0,0-1.89-.31,9,9,0,0,0-1.93.1.67.67,0,0,0,0,.2,8.75,8.75,0,0,0,1.9.3,9.68,9.68,0,0,0,1.78-.07c.17,0,.35-.06.53-.1Zm-26.87,18.15a8.66,8.66,0,0,0-.43,2.28,8.19,8.19,0,0,0,.17,2.31,7.85,7.85,0,0,0,.43-2.28A8.25,8.25,0,0,0,568.22,310.06Zm23.91-31.82-.51.23c0,.22,0,.43-.07.64s0,.14,0,.21a8,8,0,0,0,.18,2.32,8.71,8.71,0,0,0,.42-2.28c0-.18,0-.37,0-.54S592.14,278.43,592.13,278.24ZM558,307a7.34,7.34,0,0,0-.86.6l-.47.39a8.6,8.6,0,0,0-1.52,1.76,7.19,7.19,0,0,0,1.62-1.06l.3-.25c.21-.19.41-.39.61-.6a6.83,6.83,0,0,0,.9-1.15A5.33,5.33,0,0,0,558,307Zm24.4-5.8a8.26,8.26,0,0,0-1.51,1.76,9.13,9.13,0,0,0,3.43-3.06A8,8,0,0,0,582.38,301.15Zm-21.85-11-.09-.11-.24-.25c-.1-.11-.21-.22-.32-.32a6.2,6.2,0,0,0-1.2-.95,6.12,6.12,0,0,0,.78,1.25,3.17,3.17,0,0,0,.28.36l.25.3.06.06a7.5,7.5,0,0,0,1.7,1.46A7.81,7.81,0,0,0,560.53,290.1Zm18.51.19a8.5,8.5,0,0,0-1.75-1.51,8,8,0,0,0,1.3,1.91,8.07,8.07,0,0,0,1.76,1.52A8.35,8.35,0,0,0,579,290.29Zm30.16-10.85-.05-.06a7.91,7.91,0,0,0-1.74-1.51,8.15,8.15,0,0,0,1.3,1.91l.27.29c.13.13.26.26.4.38l.12-.28a2.58,2.58,0,0,0,.08-.26A6,6,0,0,0,609.2,279.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.86,314.37c2.72-8.32,5.49-16.67,9-24.7,0-.07.15,0,.12.06-2.45,8.4-5.71,16.57-9,24.69C555,314.52,554.82,314.48,554.86,314.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.08,309.26c3.81-3.41,16.85-14.22,20.74-17.54a0,0,0,0,1,.06.06,60.43,60.43,0,0,1-4.47,4.58c.69-.44,1.37-.9,2.08-1.3.06,0,.13,0,.07.09a11.57,11.57,0,0,1-1.85,1.33c-.35.21-.72.4-1.08.6-3.64,4.21-13.34,10.72-15.45,12.31C581.11,309.45,581,309.32,581.08,309.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.23,236.6C617,239.19,623.05,245,624.75,266s-1.55,36.41-7.73,40.07-19.63,1.74-26.83-3.79c0,0,14.82-15.71,17-38.75.69-7.36-3.8-18.9-.94-24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.32,301.17c1.09-1.65,2.08-3.37,3.14-5s2.07-3.28,3.07-4.94a100.57,100.57,0,0,0,5.54-10.34,59.54,59.54,0,0,0,5.71-22.51c.16-4.69-.36-9.31-.63-14,0-.08.14-.1.15,0,1.38,8.08,2,16.4.12,24.45a72.85,72.85,0,0,1-9.22,21.49c-1.14,1.88-2.35,3.71-3.61,5.5s-2.76,3.64-4.13,5.47C589.4,301.34,589.26,301.26,589.32,301.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.23,242.71c-.06-.07.07-.17.13-.1,5.2,6.38,7.3,14.7,8.65,22.66a67.19,67.19,0,0,1-.57,26.91,39.39,39.39,0,0,1-2.23,6.68,38.34,38.34,0,0,1-3.42,5.88c-.06.1-.21,0-.13-.1a19.15,19.15,0,0,0,3-5.59,42.34,42.34,0,0,0,1.63-5.75,67.38,67.38,0,0,0,1.57-13.12,87.58,87.58,0,0,0-3-25.33A38,38,0,0,0,617.23,242.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.47,297.06a59.08,59.08,0,0,0,2.2-5.86,60,60,0,0,0,2.49-12.15A54.46,54.46,0,0,0,624,254.89a61.42,61.42,0,0,0-6.34-12.33c0-.07.06-.15.11-.08A52.09,52.09,0,0,1,625.88,290a51.81,51.81,0,0,1-2.63,6.42c-1.07,2.2-2.41,4.24-3.61,6.37,0,.1-.2,0-.14-.09A31.92,31.92,0,0,0,622.47,297.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.21,254.39s3.72-4.4,5.74-3-1.06,7.95-3.65,8.66a2.56,2.56,0,0,1-3.29-1.68Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,253.23a0,0,0,0,1,0,.06,6.48,6.48,0,0,0-3.7,3.73,1.41,1.41,0,0,1,2.14-.2s0,.11-.05.09a1.58,1.58,0,0,0-1.78.39,7.76,7.76,0,0,0-.95,1.32c-.1.15-.37,0-.3-.13l0,0C606.57,256.21,608.6,253.23,611,253.23Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-125"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.31,
    y: 108.21,
    width: 389.84,
    height: 260.77,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.14,
    y: 111.39,
    width: 384.17,
    height: 254.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.54,
    y: 388.54,
    width: 491.38,
    height: 17.9,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.54 388.54 115.31 368.98 505.15 368.98 555.92 388.54 64.54 388.54",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.85 381.6 152.61 368.98 467.85 368.98 500.61 381.6 119.85 381.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.86,
    y: 130.72,
    width: 340.75,
    height: 215.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.86,
    y: 139.02,
    width: 340.75,
    height: 53.09,
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.92,
    y: 149.33,
    width: 82.91,
    height: 11.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,160.51H379.8v-11.3h83.14ZM380,160.28h82.69V149.44H380Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.65,
    y: 149.21,
    width: 11.3,
    height: 11.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.8,158l-1,.78-1.89-2.5-.69-.92a1.69,1.69,0,0,0,.39-.22,1.73,1.73,0,0,0,.53-.68l.73,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.79,152.07a2.79,2.79,0,1,0-.9,4.17c.13-.08.26-.16.38-.25a2.74,2.74,0,0,0,.58-.6A2.81,2.81,0,0,0,458.79,152.07Zm-1.2,3a1.67,1.67,0,1,1,.31-2.34,1.67,1.67,0,0,1,.22,1.66A1.73,1.73,0,0,1,457.59,155.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.23,
    y: 151.5,
    width: 0.59,
    height: 6.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.8,
    y: 149.33,
    width: 190.96,
    height: 11.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.87,160.51H184.68v-11.3H375.87Zm-191-.23H375.64V149.44H184.91Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.11,
    y: 151.5,
    width: 0.59,
    height: 6.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.91 158.65 159.88 154.94 163.9 151.08 164.53 151.73 161.2 154.92 164.52 157.98 163.91 158.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.64 151.07 177.67 154.78 173.64 158.64 173.02 157.99 176.35 154.8 173.03 151.74 173.64 151.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.86,
    y: 130.72,
    width: 340.75,
    height: 8.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.67,134.87a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,147.67,134.87Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,134.87a1.58,1.58,0,1,1-1.58-1.57A1.57,1.57,0,0,1,154.09,134.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.93,
    cy: 134.87,
    r: 1.57,
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.68,207.29A36.38,36.38,0,1,1,241,183.39,36.4,36.4,0,0,1,286.68,207.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.09,250.32a33.79,33.79,0,1,1,22.11-42.26A33.77,33.77,0,0,1,262.09,250.32Zm19-40.71a30.32,30.32,0,1,0-20.91,37.67A30.34,30.34,0,0,0,281.05,209.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.4,197.84l3.32-1.05.3,1c.41,1.3.83,2.58,1.21,3.88.15.49.35.55.84.47a25.31,25.31,0,0,1,4.32-.5c3.72,0,6.16,2.07,7,5.69a15.28,15.28,0,0,1,.37,2,5.37,5.37,0,0,1-1.68,4.45l-.93.91c.62.05,1.16.08,1.7.16A7.26,7.26,0,0,1,268,220a10.6,10.6,0,0,1,.7,4.16,7,7,0,0,1-2.4,4.94,16.37,16.37,0,0,1-5.71,3.17c-.49.18-.64.35-.46.88.43,1.26.78,2.55,1.19,3.82.1.32.07.52-.26.62l-2.85.9c-.13-.43-.25-.81-.37-1.19-.34-1.08-.69-2.15-1-3.23-.11-.37-.26-.51-.65-.37-.61.22-1.24.4-1.93.62l1.55,4.9-3.32,1.05c-.52-1.63-1-3.23-1.55-4.9l-8.23,2.6c-.6-1.89-1.17-3.7-1.76-5.58l2.43-.76c-2-6.41-4-12.74-6-19.13l-2.41.76c-.59-1.86-1.16-3.67-1.75-5.55l8.19-2.59-1.71-5.42,3.3-1,1.68,5.35,2.44-.77C246.53,201.41,246,199.66,245.4,197.84Zm6.66,22.63c-.55.17-1.09.36-1.65.51-.36.1-.43.28-.32.63.71,2.21,1.41,4.41,2.09,6.63.13.43.34.48.72.35.95-.32,1.92-.6,2.87-.92a3.67,3.67,0,0,0,2.61-4.2,3.8,3.8,0,0,0-5.21-3.35ZM247.38,213c.3.94.6,1.87.89,2.82.09.31.24.44.57.32,1-.34,2-.63,3-1a2.3,2.3,0,0,0,1.5-2.5,7.78,7.78,0,0,0-.53-2.07,2.88,2.88,0,0,0-3.73-1.7c-.75.23-1.49.49-2.24.7-.36.1-.44.28-.32.62C246.8,211.14,247.09,212.08,247.38,213Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.94,191.21a30.07,30.07,0,0,1,9.41,7.25,30.68,30.68,0,0,1,5.86,10.42,30.22,30.22,0,0,1,1.37,11.91,30.37,30.37,0,0,1-10.89,20.88,30,30,0,0,1-33.78,3.3,30.49,30.49,0,0,0,33.22-4,30.53,30.53,0,0,0,10.58-20.28,30.5,30.5,0,0,0-15.77-29.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,245a30.09,30.09,0,0,1-9.39-7.28,30.6,30.6,0,0,1-5.83-10.44,30,30,0,0,1-1.33-11.91,30.35,30.35,0,0,1,11-20.85,30.17,30.17,0,0,1,10.57-5.67,30.53,30.53,0,0,1,11.9-1.12,29.76,29.76,0,0,1,11.32,3.6,30.47,30.47,0,0,0-33.23,3.86A30.5,30.5,0,0,0,222,215.43,30.47,30.47,0,0,0,237.69,245Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.94,213.21c-.17-.45-.34-.91-.5-1.36s-.34-.91-.5-1.37l-.94-2.76-.07-.19.2-.06q4.06-1.36,8.19-2.59l-.13.26-.79-2.74L240,201q-.19-.69-.36-1.38c.17.45.33.89.49,1.34l.49,1.34.92,2.68.07.19-.2.07q-4.06,1.36-8.19,2.58l.13-.25.81,2.8c.13.46.25.94.38,1.4S234.83,212.74,234.94,213.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72,237.92c-.34-.92-.65-1.84-1-2.76s-.63-1.84-.94-2.77l-.05-.15.15-.05,2.42-.81-.13.26-1.54-4.77c-.51-1.59-1-3.2-1.49-4.79s-1-3.2-1.45-4.8-.92-3.21-1.37-4.83c.57,1.58,1.12,3.15,1.65,4.74s1.07,3.17,1.58,4.76,1,3.18,1.52,4.78l1.48,4.79.07.19-.2.06-2.44.73.1-.2c.27.93.56,1.86.82,2.8S242.47,237,242.72,237.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,228.59c.51-.22,1-.41,1.55-.62l1.57-.56a3.54,3.54,0,0,0,2-2.22,4.27,4.27,0,0,0-.29-3.07,4,4,0,0,0-.94-1.29,3.79,3.79,0,0,0-1.38-.86,3.84,3.84,0,0,1,2.64,2,4.34,4.34,0,0,1,.43,3.38,3.74,3.74,0,0,1-2.39,2.43C255.06,228.06,254,228.35,252.9,228.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,216.13c.83-.37,1.71-.7,2.54-1a2.74,2.74,0,0,0,1.45-2,4,4,0,0,0-.41-2.51,4.47,4.47,0,0,0-1.81-1.92,3.9,3.9,0,0,1,2.13,1.75,4,4,0,0,1,.56,2.78,3,3,0,0,1-1.78,2.21C250.75,215.74,249.87,215.93,249,216.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,235.32a11.78,11.78,0,0,1,1,2.38,12.43,12.43,0,0,1,.55,2.52,11.78,11.78,0,0,1-1-2.38A12.58,12.58,0,0,1,251,235.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.58,233.62a12.16,12.16,0,0,1,1,2.36,11.73,11.73,0,0,1,.54,2.5,12.16,12.16,0,0,1-1-2.36A11.6,11.6,0,0,1,256.58,233.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404,188.36a36.38,36.38,0,1,1-27.7-43.45A36.39,36.39,0,0,1,404,188.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,213.45A33.78,33.78,0,1,1,401.5,187.8,33.76,33.76,0,0,1,361.31,213.45ZM398,187.57a30.32,30.32,0,1,0-36.88,22.27A30.34,30.34,0,0,0,398,187.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,159.62l3.4.74-.21,1c-.29,1.33-.56,2.65-.88,4-.12.49,0,.65.49.82a27.34,27.34,0,0,1,4,1.71c3.22,1.88,4.31,4.86,3.26,8.44a15.45,15.45,0,0,1-.68,1.91,5.32,5.32,0,0,1-3.67,3c-.39.11-.79.2-1.26.32.51.36,1,.65,1.4,1a7.23,7.23,0,0,1,2.77,7.53,10.53,10.53,0,0,1-1.46,4,7,7,0,0,1-4.53,3.09A16.55,16.55,0,0,1,369,197c-.51-.09-.72,0-.83.53-.26,1.31-.59,2.6-.88,3.91-.07.32-.19.48-.53.41l-2.91-.64c.09-.43.18-.83.26-1.22.24-1.1.47-2.21.73-3.31.09-.37,0-.57-.39-.64-.64-.11-1.27-.27-2-.42-.38,1.71-.73,3.34-1.1,5l-3.4-.75c.36-1.67.72-3.3,1.09-5l-8.43-1.84c.42-1.94.83-3.79,1.25-5.72l2.49.55c1.43-6.56,2.85-13,4.28-19.6l-2.47-.53c.41-1.91.82-3.77,1.24-5.69l8.39,1.83c.41-1.89.81-3.7,1.22-5.56l3.37.74c-.39,1.8-.79,3.61-1.19,5.48l2.5.55C372.14,163.29,372.54,161.49,372.94,159.62Zm-5.49,22.95c-.56-.13-1.12-.23-1.68-.38-.36-.09-.51,0-.59.38-.48,2.27-1,4.54-1.49,6.8-.1.43.06.58.45.66,1,.19,2,.43,2.95.62a3.64,3.64,0,0,0,4.35-2.34,3.79,3.79,0,0,0-2.85-5.49Zm-.35-8.79c-.21,1-.41,1.92-.63,2.88-.07.32,0,.51.34.57,1,.2,2,.45,3.08.6a2.29,2.29,0,0,0,2.54-1.42,7.89,7.89,0,0,0,.57-2.06,2.88,2.88,0,0,0-2.39-3.33c-.76-.18-1.53-.32-2.29-.51-.37-.09-.52,0-.59.38C367.54,171.85,367.32,172.81,367.1,173.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,164.09a29.84,29.84,0,0,1,4.55,11,30.62,30.62,0,0,1-.09,12,30.25,30.25,0,0,1-4.74,11,30.68,30.68,0,0,1-8.64,8.35,31,31,0,0,1-11.2,4.35,30.29,30.29,0,0,1-22.88-5.22,29.87,29.87,0,0,1-8.06-8.74,30.51,30.51,0,0,0,30.79,13.1,30.6,30.6,0,0,0,19.27-12.34,30.48,30.48,0,0,0,1-33.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8,196.68a29.8,29.8,0,0,1-4.52-11,30.43,30.43,0,0,1,.13-11.95,30,30,0,0,1,4.78-11,30.35,30.35,0,0,1,19.87-12.63,29.89,29.89,0,0,1,12,.34,30.51,30.51,0,0,1,10.88,4.94,30,30,0,0,1,8,8.76A30.49,30.49,0,0,0,363.21,151a30.14,30.14,0,0,0-10.85,4.26,29.8,29.8,0,0,0-8.46,8,30.5,30.5,0,0,0-1.1,33.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.22,167.76c.07-.49.15-1,.24-1.44s.16-1,.25-1.44l.55-2.86,0-.19.2,0q4.22.84,8.4,1.83l-.24.16.68-2.77.35-1.37c.12-.46.25-.92.38-1.38l-.24,1.41-.25,1.4-.53,2.79,0,.2-.2,0q-4.21-.85-8.39-1.84l.24-.15-.7,2.83c-.11.47-.24.94-.36,1.41S356.35,167.29,356.22,167.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.67,193.06c.16-1,.35-1.92.53-2.88s.37-1.91.56-2.87l0-.16.16,0,2.5.5-.24.15,1-4.9c.35-1.64.73-3.26,1.09-4.89s.75-3.26,1.14-4.89.79-3.25,1.21-4.87c-.3,1.65-.6,3.3-.93,4.93s-.65,3.28-1,4.92-.69,3.27-1.05,4.9l-1.1,4.89-.05.2-.2,0-2.48-.59.19-.12c-.23.94-.44,1.89-.68,2.84S350.92,192.11,350.67,193.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.14,190c.56.06,1.1.16,1.65.24l1.64.29a3.58,3.58,0,0,0,2.88-.91,4.29,4.29,0,0,0,1.27-2.81,3.92,3.92,0,0,0-.17-1.59,3.69,3.69,0,0,0-.77-1.43,3.82,3.82,0,0,1,1.31,3,4.29,4.29,0,0,1-1.32,3.14,3.67,3.67,0,0,1-3.27.91C366.28,190.64,365.21,190.36,364.14,190Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.93,177.26c.91.1,1.84.25,2.71.39a2.73,2.73,0,0,0,2.23-1,4,4,0,0,0,.9-2.38,4.55,4.55,0,0,0-.62-2.58,3.9,3.9,0,0,1,1,2.58,4,4,0,0,1-.9,2.69,3,3,0,0,1-2.64,1C368.67,177.81,367.81,177.54,366.93,177.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,194.9a12.89,12.89,0,0,1-.31,2.56,12.69,12.69,0,0,1-.78,2.45,11.57,11.57,0,0,1,.31-2.56A12,12,0,0,1,359.1,194.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.83,196.22a12.6,12.6,0,0,1-.31,2.54,12.23,12.23,0,0,1-.78,2.45,12.62,12.62,0,0,1,.31-2.55A12,12,0,0,1,364.83,196.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.19,316.72a36.38,36.38,0,1,1-27.69-43.45A36.39,36.39,0,0,1,390.19,316.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46,341.81a33.78,33.78,0,1,1,40.2-25.65A33.76,33.76,0,0,1,347.46,341.81Zm36.69-25.88a30.32,30.32,0,1,0-36.88,22.28A30.33,30.33,0,0,0,384.15,315.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,288l3.39.74-.21,1c-.29,1.33-.56,2.65-.88,4-.12.49,0,.65.5.82a26.66,26.66,0,0,1,4,1.72c3.22,1.87,4.32,4.85,3.26,8.43a14,14,0,0,1-.68,1.91,5.32,5.32,0,0,1-3.67,3c-.39.11-.79.2-1.26.32.51.36,1,.65,1.4,1a7.24,7.24,0,0,1,2.77,7.54,10.37,10.37,0,0,1-1.46,3.95,7,7,0,0,1-4.53,3.09,16.55,16.55,0,0,1-6.54-.09c-.51-.09-.72,0-.83.53-.25,1.31-.59,2.61-.87,3.91-.07.32-.2.48-.54.41L350,329.6c.09-.44.18-.84.27-1.23.24-1.1.47-2.21.72-3.31.09-.37,0-.57-.38-.64-.64-.11-1.28-.27-2-.42-.37,1.71-.73,3.34-1.1,5l-3.4-.75c.36-1.67.72-3.3,1.09-5l-8.43-1.84c.42-1.94.83-3.79,1.25-5.72l2.49.55c1.43-6.56,2.85-13.05,4.28-19.59l-2.47-.54c.42-1.91.82-3.76,1.24-5.69l8.39,1.83c.42-1.89.81-3.7,1.22-5.56l3.38.74c-.4,1.8-.79,3.62-1.2,5.48l2.5.55C358.3,291.65,358.69,289.85,359.1,288Zm-5.5,22.95c-.56-.12-1.12-.23-1.68-.38-.36-.09-.51,0-.59.39-.48,2.26-1,4.53-1.48,6.79-.1.43,0,.58.45.66,1,.19,2,.43,2.94.62a3.66,3.66,0,0,0,4.36-2.34,3.8,3.8,0,0,0-2.85-5.49Zm-.34-8.79c-.21,1-.41,1.92-.64,2.88-.07.32,0,.51.34.57,1,.2,2.05.45,3.08.6a2.29,2.29,0,0,0,2.54-1.42,7.92,7.92,0,0,0,.58-2.06,2.88,2.88,0,0,0-2.4-3.33c-.76-.18-1.53-.32-2.28-.51-.37-.09-.52,0-.6.38C353.69,300.21,353.47,301.17,353.26,302.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.2,292.45a29.86,29.86,0,0,1,4.56,11,30.62,30.62,0,0,1-.1,11.95,30.08,30.08,0,0,1-4.74,11,30.68,30.68,0,0,1-8.64,8.35,31,31,0,0,1-11.2,4.35,30.32,30.32,0,0,1-22.88-5.22,29.87,29.87,0,0,1-8.06-8.74,30.51,30.51,0,0,0,30.79,13.1A30.47,30.47,0,0,0,379.2,325.9a30.51,30.51,0,0,0,1-33.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,325a30.15,30.15,0,0,1-4.52-11,30.81,30.81,0,0,1,.13-11.95,30,30,0,0,1,4.78-11,30.35,30.35,0,0,1,19.87-12.63,29.89,29.89,0,0,1,12,.34,30.51,30.51,0,0,1,10.88,4.94,30.09,30.09,0,0,1,8,8.76,30.49,30.49,0,0,0-30.75-13.19,30.5,30.5,0,0,0-19.31,12.28A30.5,30.5,0,0,0,329,325Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,296.12c.07-.48.16-1,.24-1.44s.16-1,.26-1.44l.54-2.86,0-.19.21,0q4.2.84,8.39,1.83l-.24.16.68-2.77.36-1.37c.12-.46.24-.92.37-1.38q-.11.71-.24,1.41l-.24,1.4-.54,2.79,0,.2-.2,0c-2.81-.57-5.6-1.18-8.39-1.84l.24-.15-.69,2.83c-.12.47-.25.94-.37,1.41S342.5,295.65,342.37,296.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.82,321.42c.17-1,.35-1.92.53-2.88s.38-1.91.56-2.87l0-.16.16,0,2.5.5-.24.15,1-4.9c.35-1.64.73-3.26,1.09-4.89s.75-3.26,1.14-4.89.79-3.25,1.21-4.86c-.29,1.64-.6,3.29-.93,4.92s-.65,3.28-1,4.92-.68,3.27-1.05,4.9l-1.1,4.89-.05.2-.19,0-2.49-.59.2-.12c-.23.94-.45,1.9-.69,2.84S337.07,320.47,336.82,321.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.3,318.39c.55.06,1.1.16,1.65.24l1.64.29a3.56,3.56,0,0,0,2.87-.91,4.46,4.46,0,0,0,1.11-4.4,4,4,0,0,0-.77-1.43,3.86,3.86,0,0,1,1.3,3,4.32,4.32,0,0,1-1.31,3.14,3.7,3.7,0,0,1-3.28.91C352.43,319,351.36,318.72,350.3,318.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.09,305.62c.9.1,1.83.25,2.7.39a2.76,2.76,0,0,0,2.24-1,4,4,0,0,0,.89-2.38,4.5,4.5,0,0,0-.61-2.57,3.9,3.9,0,0,1,1,2.57,4,4,0,0,1-.89,2.69,3,3,0,0,1-2.65,1C354.82,306.17,354,305.9,353.09,305.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.25,323.26a12.19,12.19,0,0,1-.31,2.56,12,12,0,0,1-.78,2.45,12.89,12.89,0,0,1,.31-2.56A12.69,12.69,0,0,1,345.25,323.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,324.58a11.32,11.32,0,0,1-.31,2.54,12,12,0,0,1-.78,2.45,13.63,13.63,0,0,1,1.09-5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.75,346.47h-33.9l-.39,1.49c0-.5,0-1,0-1.49h-6.16l-.54-61.61v-.17l-.05-5.87v-2.95l-.05-5.38h0l0-1.65-.1-11.63v-.45h37.56l.39,9.57v.19l.18,4.36.11,2.6v.58l.12,2.88.29,7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,346.47h-.68l-.39,1.49c0-.5,0-1,0-1.49,0-1.37,0-2.75,0-4.12q-.06-6.24-.1-12.47-.09-13.71-.11-27.44,0-7.28,0-14.57c0-3.51,0-7,0-10.54,0-1.09,0-2.17,0-3.26q0-5.76.12-11.54s.05,0,.06,0c.09,3.63.16,7.25.21,10.88,0,1.31,0,2.62.06,3.92,0,3.6.08,7.2.12,10.8.06,6.39.11,12.79.21,19.18q.13,9.15.28,18.31h0q.14,9.21.28,18.41C291.5,344.85,291.52,345.66,291.53,346.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6,256.75l-.32,1.21v0l-.11.43-1.1,4.14-.84,3.18-.66,2.49-.8,3-1.57,5.9L306.33,288l-1,3.83-.15.58-.08.28,0,.13-.8,3-.16.61-.13.49L291.49,344l-.64,2.43-.39,1.49c0-.5,0-1,0-1.49h-6.16l-.54-61.61v-.17l-.05-5.87v-1.46l0-1.48,0-5.39h0l0-1.65-.1-11.63v-.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,256.71a.16.16,0,0,1,0,0c-.06.27-.4,1.85-.93,4.24,0,0,0,.05,0,.08s0,.15-.05.23c-.27,1.18-.57,2.54-.91,4-.23,1-.46,2-.71,3h0c-.65,2.76-1.37,5.78-2.12,8.75-.26,1-.52,2-.78,3-.55,2.12-1.1,4.17-1.63,6a42.77,42.77,0,0,1-3,8.42,1.75,1.75,0,0,1-.52.61c-.41.24-1.3.68-2.41,1.2l-.5.23-.57.27c-2.32,1.06-5.1,2.28-6.41,2.83h0a.28.28,0,0,0,0,.08c-.21,1-2.36,11.69-5.36,25.77h0c-.3,1.39-.6,2.8-.91,4.25-1.13,5.27-2.36,10.89-3.63,16.59H242.94c7.2-26,15-55.43,15-55.43a106.84,106.84,0,0,1,1-13.68c.3-2.2.7-4.5,1.21-6.79,0-.16.07-.32.11-.48a1.89,1.89,0,0,0,.05-.23c0-.17.08-.33.13-.5,1.16-4.77,2.88-9.37,5.41-12.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,284.4a35.79,35.79,0,0,1,3.59-.58c.95-.16,1.91-.32,2.85-.53a12.47,12.47,0,0,0,5-2.13c1.64-1.27,2.48-3.21,3.27-5.07.47-1.11,1-2.21,1.45-3.3.24-.54.48-1.07.73-1.59a18.3,18.3,0,0,0,.89-1.91c0-.1.18-.05.15,0a12.72,12.72,0,0,0-.41,1.37l-.47,1.61c-.3.94-.59,1.9-.9,2.84a22.39,22.39,0,0,1-2,5c-1.75,2.78-4.88,3.91-8,4.3-.9.12-1.81.18-2.71.23a18.61,18.61,0,0,1-3.42,0A.16.16,0,0,1,268.82,284.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,293.52a84.92,84.92,0,0,0-13.29,6.2.15.15,0,0,0,.12.27c4.48-1.92,9.05-3.76,13.41-5.93A.3.3,0,0,0,309.94,293.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.29,262.85c0-.16-.28-.19-.28,0,0,5.31-.31,10-.75,15-.21,2.31-2.07,15.06-6.07,14.13-.67-.16-1-.82-1.11-1.83a15.93,15.93,0,0,1,.53-3.91c.44-2.67.8-5.34,1-8a73.09,73.09,0,0,0-.17-15.08.13.13,0,0,0-.25,0A139.3,139.3,0,0,1,303,283.89c-.5,3.32-2.17,8.31,1.3,8.82s5.81-7.84,6.24-10.13A76.23,76.23,0,0,0,311.29,262.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.3,292.26a22.81,22.81,0,0,0-.9,2.64,6,6,0,0,0-.37,2.17.15.15,0,0,0,.27.06,7.41,7.41,0,0,0,.93-2.11c.31-.82.63-1.63.91-2.45A.45.45,0,0,0,304.3,292.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19,278.47c.19,3,1,6,.95,9.11a44.28,44.28,0,0,1-1.54,9q-4.34,18.66-9.3,37.14-1.71,6.39-3.5,12.76h-1c.81-2.9,1.62-5.81,2.41-8.72q5-18.37,9.41-36.92c.74-3.09,1.54-6.18,2.14-9.3a28.49,28.49,0,0,0,0-9.53,36.05,36.05,0,0,1-.35-4.62,25.53,25.53,0,0,1,.24-3.9c0-.11,0-.23.05-.34s0-.18,0-.27,0-.16,0-.24.07-.39.1-.59a61.43,61.43,0,0,1,1.89-7.56c.47-1.5,1-3,1.49-4.46a.14.14,0,0,1,.26.08,78.7,78.7,0,0,0-3.06,12.37c0,.21-.06.42-.08.63a1.94,1.94,0,0,0,0,.24q0,.32-.06.63a27.55,27.55,0,0,0-.13,3.41C264.15,277.74,264.16,278.11,264.19,278.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,201.64c2.61,12.44,18.79,46.64,28.81,53.64,5.84,4.08,42.36,19.83,44.54,15.91,2-3.65,1.45-31.77,1.45-31.77-8.55-2.53-32.3-9.3-35-9.76-1.93-.32-15-16.15-29-32.11C300.26,188.71,295.67,194.21,297.23,201.64Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.3,235.22,362.25,273s-29.91-10.3-38.72-17.64-22.56-35.56-26.6-50.4,2.86-18,15-4.58c10,11,23.27,26.66,25.08,27.5S364.3,235.22,364.3,235.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,204.94c4,14.84,17.79,43.07,26.6,50.4,4.66,3.9,15.26,8.61,24.19,12.19l.24.09L297.71,193a4.52,4.52,0,0,0-.75.09C295.45,195,295.32,199,296.93,204.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.24,268.05c.57-5.34,2.08-27.25,2.09-32,0-.33-.21-.41-.25-.07-2.08,15.95-1.76,26.79-2.05,32C354,268.15,354.23,268.18,354.24,268.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58,277.31c.17.18,69.76.07,70.39-.65.88-1-16.34-72.87-21.14-83.58-2.05-4.57-13.21-6-17.91-2.08-11.79,9.69-21.76,42.88-24.06,52.88C259.06,260.36,255,276.66,255.58,277.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,194.24s-.05,0-.05,0c.2,3.16.46,10.48-4.5,10a10.54,10.54,0,0,1-5.33-2.63,28.26,28.26,0,0,1-4.21-4.26,40.3,40.3,0,0,1-3.92-5.46c-.05-.09-.17,0-.12.08,1.17,1.93,2.16,3.93,3.52,5.75a24.12,24.12,0,0,0,4.54,4.71c1.63,1.25,3.57,2.49,5.68,2.58a4,4,0,0,0,4.06-3A17.67,17.67,0,0,0,305.18,194.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,200.92c-3.56.36-9.49-6.25-11.26-10.84-.12-.32.74-3.35,1.62-7.08.52-2.27,1-4.81,1.36-7.16l14.26,5.55a37.62,37.62,0,0,0-2.63,8.83,5.43,5.43,0,0,0,0,1,.85.85,0,0,1,0,.16C304.27,193.23,304.34,200.57,300.89,200.92Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.69,191.24a9.2,9.2,0,0,0,1.52.12c0-.07,0-.12,0-.16a5.4,5.4,0,0,1,0-1,37.83,37.83,0,0,1,2.62-8.83L293.06,176C293.23,179.45,294.43,190,302.69,191.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,162.32c-.9,5.44,3.87,20.17,8,23,6,4.16,14.92,3.45,18.21-3.57,3.18-6.82-3.37-25.9-7.93-28.41C300.54,149.69,290.27,154.29,288.94,162.32Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.49,169.94s-.07.07-.05.11c.35,1,.58,2.17-.22,2.78,0,0,0,.07,0,.06C306.3,172.38,306,170.81,305.49,169.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.27,169.18c-1.64.39-.74,3.63.77,3.28S305.64,168.86,304.27,169.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.05,168.34s.09,0,.1.07c.24,1,.7,2.13,1.7,2.21,0,0,0,.06,0,.06C311.7,170.83,311.12,169.34,311.05,168.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,167c1.58-.57,2.6,2.64,1.13,3.17S310.33,167.52,311.66,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.58,168.05a12.69,12.69,0,0,0,1.13-.79c.44-.31.81-.51,1-1a.71.71,0,0,0-.34-.8,1.79,1.79,0,0,0-1.77.29,2.59,2.59,0,0,0-1.14,1.48A.76.76,0,0,0,302.58,168.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46,165.06a12.71,12.71,0,0,1-1.38,0,2.25,2.25,0,0,1-1.42-.24.74.74,0,0,1-.19-.85,1.76,1.76,0,0,1,1.61-.79,2.62,2.62,0,0,1,1.79.53A.76.76,0,0,1,312.46,165.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.55,179.41a1.56,1.56,0,0,0,1,.36,2.94,2.94,0,0,0,1-.55s.07,0,.05,0a1.38,1.38,0,0,1-1.12.89,1.1,1.1,0,0,1-1-.67S306.5,179.39,306.55,179.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.77,176.11a3.53,3.53,0,0,0,2.71.89,4.61,4.61,0,0,0,1.25-.28,1.45,1.45,0,0,0,.22-.09l.21-.1a.25.25,0,0,0,.14-.28h0a.49.49,0,0,0,0-.11h0l0-.09c-.2-.78-.6-1.94-.6-1.94.33.07,1.95.32,1.81-.08a53.47,53.47,0,0,0-4.18-10c-.06-.11-.22,0-.18.07,1,3.21,2.47,6.23,3.48,9.43a6.57,6.57,0,0,0-1.76,0c-.1.06.82,2.22.88,2.58v0a4.93,4.93,0,0,1-3.85-.13C306.75,176,306.69,176.05,306.77,176.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,176.45a4.18,4.18,0,0,1-1.28,1.71,1.94,1.94,0,0,1-1.09.38c-.86,0-1.08-.72-1.11-1.39a4.9,4.9,0,0,1,.09-1.07A5.5,5.5,0,0,0,310.16,176.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.88,178.16a1.94,1.94,0,0,1-1.09.38c-.86,0-1.08-.72-1.11-1.39A2,2,0,0,1,308.88,178.16Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.7,173.69c.93-.8,2-4.68,2.57-6.29S292.06,159,291.49,157a6.89,6.89,0,0,0-.49.61,6.74,6.74,0,0,0-.45.64,9.7,9.7,0,0,0-.78,1.41,11,11,0,0,0-.83,2.71C288.53,164.83,289.31,169.31,290.7,173.69Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,158.74a5.4,5.4,0,0,1-4.21,3.18,5.52,5.52,0,0,1-5-1.94s-.11,0-.07.06a5.46,5.46,0,0,0,5.15,2.32,5.59,5.59,0,0,0,4.29-3.57A.07.07,0,0,0,306,158.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,147.53a8.53,8.53,0,0,0-5.74,5.84,6,6,0,0,0,.57,4s.13,0,.11-.05A6.71,6.71,0,0,1,293,150.6a8.64,8.64,0,0,1,7-3.06,5.46,5.46,0,0,1,3.47,1.41c.1.09.3,0,.22-.14C302.38,147.17,299.52,146.65,296.81,147.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.26,148.81a6.93,6.93,0,0,0-3.9-2.72c-2.19-.59-4.23.21-6.24,1-.06,0,0,.1,0,.08a9.63,9.63,0,0,1,5.37-1,6.85,6.85,0,0,1,4,2.27,6.65,6.65,0,0,1-.27,8.69,6.72,6.72,0,0,1-4.94,2.05c-.07,0-.09.11,0,.11a6.78,6.78,0,0,0,6-10.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84,165.93s-4.45-4.55-3-8.38c.83-2.17,5.4-3.26,5.4-3.26a8.47,8.47,0,0,1,4.17-5c3.51-2,8.64-1.09,8.64-1.09s3-3.1,6.89-2.17c5.45,1.29,7,8.58,2.94,12.25-2.83,2.58-8.18,1-8.18,1-.41.19-4,4.15-8.54,1.19,0,0-2,3.21-4.94,2.24A4.09,4.09,0,0,1,288.84,165.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8,174.19s-4.15-4.34-6.17-2.79,1.62,8.22,4.36,8.78a2.67,2.67,0,0,0,3.32-2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.72,173.29s0,.06,0,.07c1.93.45,3.15,2,4.08,3.64a1.46,1.46,0,0,0-2.23-.07.05.05,0,0,0,.06.09,1.64,1.64,0,0,1,1.87.3,7.61,7.61,0,0,1,1.08,1.31c.11.15.39,0,.3-.16l0,0C293.55,176.1,291.25,173.14,288.72,173.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--9kwdk1--inject-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.91,243a36.39,36.39,0,1,1-36.34-36.53A36.41,36.41,0,0,1,376.91,243Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M374.16,239.7a33.82,33.82,0,0,0-50.47-26.16c-.41.24-.81.48-1.21.74a33.09,33.09,0,0,0-6.69,5.56,31.33,31.33,0,0,0-2.3,2.73,33.28,33.28,0,0,0-4.51,8.16c-.25.64-.48,1.29-.68,2a34,34,0,0,0,.64,22.21c.24.62.49,1.23.76,1.82a.05.05,0,0,0,0,0,33.61,33.61,0,0,0,3.34,5.8,31.65,31.65,0,0,0,2.24,2.78,33.49,33.49,0,0,0,6.34,5.54,32.81,32.81,0,0,0,3.85,2.25,33.75,33.75,0,0,0,15,3.52c.58,0,1.16,0,1.74,0h0l.22,0a33.19,33.19,0,0,0,15.83-5c.76-.46,1.5-1,2.21-1.49s1.34-1,2-1.57l.44-.38.46-.42c.43-.39.85-.8,1.25-1.21a33.54,33.54,0,0,0,5.67-7.69c.18-.33.35-.67.52-1,.44-.89.84-1.8,1.21-2.73a33.14,33.14,0,0,0,1.44-4.76,11.74,11.74,0,0,0,.24-1.18,33.52,33.52,0,0,0,.59-6.13Q374.31,241.32,374.16,239.7Zm-15.58-21.2a28.74,28.74,0,0,1,3.39,2.93,1.21,1.21,0,0,1,.19.2A30.51,30.51,0,0,1,370.61,239l.06.57a30.71,30.71,0,0,1,.17,4,29.76,29.76,0,0,1-.61,5.3c-.07.4-.16.79-.26,1.18a29.19,29.19,0,0,1-2.89,7.43,5.06,5.06,0,0,1-.36.63,29.58,29.58,0,0,1-4,5.35,22.32,22.32,0,0,1-1.69,1.68,28.75,28.75,0,0,1-4.76,3.6,7.74,7.74,0,0,1-.73.43c-.51.31-1,.59-1.57.85l-.43.21a28.16,28.16,0,0,1-4.12,1.61l-.07,0-.14,0a30.78,30.78,0,0,1-9.7,1.29c-.62,0-1.24-.05-1.85-.11l-.16,0c-.46,0-.92-.09-1.38-.16a4.44,4.44,0,0,1-.62-.1,29.9,29.9,0,0,1-14.09-6.37c-.45-.36-.89-.74-1.32-1.15-.18-.15-.36-.31-.53-.48a29.07,29.07,0,0,1-3.33-3.78,28,28,0,0,1-1.76-2.58,0,0,0,0,0,0,0l-.24-.41c-.23-.4-.46-.81-.67-1.23a.08.08,0,0,1,0,0c-.43-.81-.81-1.64-1.16-2.49a30,30,0,0,1-2.21-12.12,29.5,29.5,0,0,1,.52-4.83c.14-.77.31-1.53.51-2.27a30.26,30.26,0,0,1,3.41-7.95,28.35,28.35,0,0,1,3.14-4.24,29.64,29.64,0,0,1,7-5.88c.42-.26.85-.5,1.28-.73a30.37,30.37,0,0,1,32.25,2.09A1.86,1.86,0,0,1,358.58,218.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M354.91,247.05A7.11,7.11,0,0,0,351,242.7c-.49-.24-1-.43-1.57-.67.43-.22.8-.39,1.16-.58a5.39,5.39,0,0,0,2.94-3.74,17,17,0,0,0,.25-2,8.77,8.77,0,0,0,0-1.54,7.13,7.13,0,0,0-.36-1.77,6.71,6.71,0,0,0-4.61-4.24,25.56,25.56,0,0,0-4.27-.82c-.49-.07-.67-.19-.66-.7,0-1.35,0-2.71,0-4.06v-1h-3.48v5.61h-2.56v-5.61h-3.45v5.69h-8.59v5.82h2.53v20.06h-2.55V259h8.63v5.14h3.48V259c.72,0,1.37,0,2,0a.57.57,0,0,1,.38.08h0a.51.51,0,0,1,.14.46v.33c0,.84,0,1.7,0,2.55v1.76h3c.26,0,.37-.11.41-.31a1.25,1.25,0,0,0,0-.21c0-.71,0-1.42,0-2.13s0-1.25,0-1.87.18-.68.7-.7l.33,0a16.21,16.21,0,0,0,6.08-1.29,7,7,0,0,0,3.49-3.34c.1-.21.2-.42.28-.64a10.81,10.81,0,0,0,.58-4.18A8.82,8.82,0,0,0,354.91,247.05Zm-16.69,6.1c-.35,0-.52-.12-.52-.55v-.22c0-2.25,0-4.48,0-6.73,0-.37.12-.52.5-.5.57,0,1.15,0,1.72,0h1.17a4.44,4.44,0,0,1,2.25.56.21.21,0,0,1,.1.06l.31.21a3.91,3.91,0,0,1,1.3,3.93,3.67,3.67,0,0,1-3.75,3.21c-1,0-2,0-3,0Zm-.52-19.46c0-.37.12-.51.5-.5.78,0,1.56,0,2.34,0a3.2,3.2,0,0,1,1.75.47,2.42,2.42,0,0,1,.36.27l.12.12a2.16,2.16,0,0,1,.39.5,3,3,0,0,1,.43,1.38,7.71,7.71,0,0,1-.12,2.14,2.29,2.29,0,0,1-2.18,1.92c-1,.08-2,.05-3,.08h-.15c-.35,0-.45-.15-.45-.48,0-1,0-2,0-3S337.72,234.67,337.7,233.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362,221.43a29.94,29.94,0,0,1,6.79,9.75,30.69,30.69,0,0,1,2.45,11.7,30,30,0,0,1-2.28,11.77,30.28,30.28,0,0,1-16.67,16.63,29.89,29.89,0,0,1-11.77,2.26,30.71,30.71,0,0,1-11.7-2.47,30.17,30.17,0,0,1-9.73-6.81,30.5,30.5,0,0,0,32.87,6.22,30.56,30.56,0,0,0,16.2-16.17A30.5,30.5,0,0,0,362,221.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.85,264.2a29.74,29.74,0,0,1-6.76-9.77,30.47,30.47,0,0,1-2.42-11.7A30.12,30.12,0,0,1,312,231a30.36,30.36,0,0,1,16.72-16.58,30.21,30.21,0,0,1,11.79-2.23,30.65,30.65,0,0,1,11.68,2.51,30,30,0,0,1,9.72,6.85A30.48,30.48,0,0,0,329,215.19a30.43,30.43,0,0,0-16.24,16.11,30.47,30.47,0,0,0,6.06,32.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.79,233.08c0-.48-.06-1-.08-1.45s0-1,0-1.46l-.08-2.91v-.2h.21q4.29-.08,8.59,0l-.21.2.08-2.84.06-1.43c0-.47,0-.94.07-1.42,0,.48.05,1,.07,1.42l.05,1.43.08,2.84v.2h-.2q-4.31.07-8.59,0l.2-.2-.08,2.91c0,.49,0,1-.05,1.46S325.82,232.6,325.79,233.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.77,259c0-1-.07-1.94-.1-2.92s0-1.95-.06-2.92V253h.17l2.55,0-.21.21,0-5c0-1.67,0-3.34,0-5s0-3.34.07-5,.08-3.35.15-5c.06,1.67.11,3.35.14,5s.07,3.34.07,5,0,3.34,0,5l0,5v.2h-.2l-2.55,0,.16-.16c0,1,0,2-.07,2.92S325.81,258,325.77,259Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.28,253.15c.56-.06,1.11-.08,1.67-.12l1.66-.07a3.51,3.51,0,0,0,2.62-1.5,4.26,4.26,0,0,0,.64-3,4,4,0,0,0-.5-1.52,4,4,0,0,0-1.06-1.23,3.82,3.82,0,0,1,1.92,2.69,4.34,4.34,0,0,1-.61,3.35,3.73,3.73,0,0,1-3,1.59C340.5,253.29,339.39,253.25,338.28,253.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.28,240.08c.91-.1,1.85-.15,2.73-.2a2.75,2.75,0,0,0,2-1.42,4.09,4.09,0,0,0,.36-2.52,4.54,4.54,0,0,0-1.15-2.38,3.91,3.91,0,0,1,1.51,2.31,4,4,0,0,1-.31,2.82,3,3,0,0,1-2.36,1.57C340.1,240.25,339.2,240.17,338.28,240.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,259a13.88,13.88,0,0,1,0,5.14,13.88,13.88,0,0,1,0-5.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.28,259.05a13.72,13.72,0,0,1,0,5.11,11.63,11.63,0,0,1-.24-2.56A12.24,12.24,0,0,1,340.28,259.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.74,230.56c2.76,4.28,8.94,9.22,9.87,12.89a4.33,4.33,0,0,1-1.79,4.85s3.95,1.37,4.25,4.83c.15,1.79-2.56,3.6-2.56,3.6s3.12,1.23,3.2,4.33c.06,2.46-2.67,3.91-2.67,3.91s2.44,2.58,1.7,5.11c-1.51,5.14-22.52,7.88-26.78.57-2-3.41,3.19-3.8,3.19-3.8s-7.57-1.24-8.25-5.55,6.07-4.42,6.07-4.42-7.32-1.26-7.57-5.81c-.26-4.73,6.51-3.68,6.51-3.68s-5.09-2.55-4.48-6.08c1-5.82,12.51-.19,17-1.89l-.58-7.55Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.36,236.67c-2.26-4.28.73-6.64-.22-11.21-1.07-5.08-7-2.94-7.33,6.15l.6,7.81Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64,265.26c.07,0,.11.08,0,.11a36.81,36.81,0,0,1-21.81,1.53c-.23-.06-.23-.46,0-.44A75.17,75.17,0,0,0,387.64,265.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.62,256.76c.08,0,.11.11,0,.14-6.91,2.63-16.11,3.27-23.9.2-.27-.11-.4-.47-.09-.37C369,258.38,380.93,258.22,387.62,256.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.41,247c7.58,2.66,15.26,2.61,23.13,1.43.1,0,.11.13,0,.17-3.69,1.63-8.79,1.85-12.77,1.7a21.33,21.33,0,0,1-10.49-3C362.19,247.18,362.25,246.93,362.41,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,199.43c-12.36,15-33,54.6-27.68,60.54,12.06,13.49,34.11,25.91,42.95,29.22,3.82,1.42,19.66-25.95,16.14-28.52-4.22-3.09-31.71-16.07-31.75-17.44s6.52-20.53,9.28-35.69C290.41,188.71,283.2,193.18,278,199.43Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.39,257.73s12.1-2.68,20.1-4.07c4.46-.77,12.23-1.41,15.77-.48,5.29,1.39,26.53,10.6,24.41,15.8-1.92,4.7-19.16-5.53-19.16-5.53s18.31,8.79,14.95,14-21.3-8.91-21.3-8.91,18.62,9.45,14.3,14.3c-3.26,3.67-20.23-8.22-20.23-8.22s15.94,8.23,12.75,12.15c-3.53,4.33-19.88-5.67-19.88-5.67-9.79,8.59-17.83,9.29-23.79,8.06C291.92,288.9,295.39,257.73,295.39,257.73Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22,260.45c14,5.44,19.17,12.39,19,12.24-4.14-3.7-11.58-7.92-13.68-9.06s-3.28-1.95-5.37-3.1C331.12,260.5,331.17,260.43,331.22,260.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.09,267.51a51,51,0,0,1,15.84,8.72c.17.16.07.19-.14.07-2.62-1.53-13.05-7.34-15.73-8.73A0,0,0,1,1,326.09,267.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.27,273.28a37.57,37.57,0,0,1,12.06,7.12c.18.14,0,.19-.19.07-4-2.44-7.06-4.39-11.93-7C321.13,273.39,321.18,273.24,321.27,273.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.44,255.06l-18.63,31.37s-33.69-21.79-34.16-29.65c-.67-11.07,22.72-50.59,29.61-58.31,6.73-7.52,11.36-6.61,9.83,4.18-1.38,9.81-9,39.38-8.92,39.81S301.44,255.06,301.44,255.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,280.56c2.89-4.52,14-23.45,16.17-27.7.15-.3,0-.46-.2-.17-9,13.33-13.54,23.17-16.14,27.75C277.29,280.55,277.46,280.67,277.53,280.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.52,210.94c0-.13.26-.09.24,0-.21,1.34-.61,3.32-1.1,5.64.06-.12.11-.25.17-.38.39-1,.74-1.93,1-2.93a.08.08,0,1,1,.16.05c-.29,1-.6,2-.95,3a16.52,16.52,0,0,1-.79,2c-2.1,9.67-5.44,23.54-5.38,23.88.09.57,18,10.38,21.69,12.62.13.08-.53,1-.6,1.15a.1.1,0,0,1-.2-.05,4.85,4.85,0,0,1,.29-.8c-3.47-1.74-21.82-11.92-22.15-12.48S285.41,215.08,286.52,210.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.35,267.61c1.08.65,11.14,8.86,12.22,9.62a.08.08,0,0,1-.09.14c-4.2-2.11-11.19-8.13-12.19-9.68C257.26,267.64,257.3,267.58,257.35,267.61Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage5);
export default __webpack_public_path__ + "static/media/image_5.1dd7d49f3905ab2ae5373ba18c33e2e2.svg";
export { ForwardRef as ReactComponent };